webpackJsonp([159],{

/***/ "/8vw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
var actions = {};

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2NXm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("Ued4");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b8ba2a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("eOxC");
function injectStyle (ssrContext) {
  __webpack_require__("l9XB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b8ba2a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b8ba2a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "3pLw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _getAes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _postAes; });
/* unused harmony export _postEncrypt */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return _postNoEncryptAes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return _postJsonAes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _get; });
/* unused harmony export _postFile */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _post; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return _postNoEncrypt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return _postJson; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return _postCors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_whatwg_fetch__ = __webpack_require__("rplX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__encrypt__ = __webpack_require__("aNLv");





var _this = this;

/**
 * Created by admin on 2017/1/12.
 */



/**
 * get请求 敏感信息
 * @param  {String} options.url   api地址
 * @param  {String} options.query query参数
 * @return {Promise}               Promise
 */
var _getAes = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(url) {
        var UserKey, UserUuid;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return Object(__WEBPACK_IMPORTED_MODULE_5__encrypt__["c" /* encryptAesKey */])();

                    case 2:
                        UserKey = _context2.sent;
                        _context2.next = 5;
                        return Object(__WEBPACK_IMPORTED_MODULE_5__encrypt__["d" /* encryptAesUuid */])();

                    case 5:
                        UserUuid = _context2.sent;
                        return _context2.abrupt('return', fetch(url, {
                            credentials: 'include',
                            headers: {
                                'User-key': UserKey,
                                'User-uuid': UserUuid
                            }
                        }).then(function () {
                            var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(res) {
                                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                                    while (1) {
                                        switch (_context.prev = _context.next) {
                                            case 0:
                                                if (!(res.status >= 200 && res.status < 300)) {
                                                    _context.next = 2;
                                                    break;
                                                }

                                                return _context.abrupt('return', res.json());

                                            case 2:
                                                return _context.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(new Error(res.status)));

                                            case 3:
                                            case 'end':
                                                return _context.stop();
                                        }
                                    }
                                }, _callee, _this);
                            }));

                            return function (_x2) {
                                return _ref2.apply(this, arguments);
                            };
                        }()));

                    case 7:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, _this);
    }));

    return function _getAes(_x) {
        return _ref.apply(this, arguments);
    };
}();

/**
 * post请求，敏感数据需要加密
 * @param  {String} url    api地址
 * @param  {Object} params 包含post内容的object
 * @return {Promise}        Promise
 */
var _postAes = function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(url, params) {
        var UserKey, UserUuid, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        _context4.next = 2;
                        return Object(__WEBPACK_IMPORTED_MODULE_5__encrypt__["c" /* encryptAesKey */])();

                    case 2:
                        UserKey = _context4.sent;
                        _context4.next = 5;
                        return Object(__WEBPACK_IMPORTED_MODULE_5__encrypt__["d" /* encryptAesUuid */])();

                    case 5:
                        UserUuid = _context4.sent;

                        if (!corvent(params)) {
                            _context4.next = 13;
                            break;
                        }

                        _context4.next = 9;
                        return Object(__WEBPACK_IMPORTED_MODULE_5__encrypt__["b" /* encryptAes */])(corvent(params));

                    case 9:
                        _context4.t1 = _context4.sent;
                        _context4.t0 = 'encryptionData=' + _context4.t1;
                        _context4.next = 14;
                        break;

                    case 13:
                        _context4.t0 = corvent(params);

                    case 14:
                        data = _context4.t0;
                        return _context4.abrupt('return', fetch(url, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                                'Accept': 'application/json',
                                'User-key': UserKey,
                                'User-uuid': UserUuid
                            },
                            credentials: 'include',
                            mode: 'cors',
                            body: data
                        }).then(function () {
                            var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(res) {
                                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                                    while (1) {
                                        switch (_context3.prev = _context3.next) {
                                            case 0:
                                                if (!(res.status >= 200 && res.status < 300)) {
                                                    _context3.next = 2;
                                                    break;
                                                }

                                                return _context3.abrupt('return', res.json());

                                            case 2:
                                                return _context3.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(new Error(res.status)));

                                            case 3:
                                            case 'end':
                                                return _context3.stop();
                                        }
                                    }
                                }, _callee3, _this);
                            }));

                            return function (_x5) {
                                return _ref4.apply(this, arguments);
                            };
                        }()));

                    case 16:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, _this);
    }));

    return function _postAes(_x3, _x4) {
        return _ref3.apply(this, arguments);
    };
}();

/**
 * post请求，敏感信息需要加密
 * @param  {String} url    api地址
 * @param  {Object} params 包含post内容的object
 * @return {Promise}        Promise
 */
var _postEncrypt = function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(url, params) {
        var UserKey, UserUuid, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        _context5.next = 2;
                        return Object(__WEBPACK_IMPORTED_MODULE_5__encrypt__["c" /* encryptAesKey */])();

                    case 2:
                        UserKey = _context5.sent;
                        _context5.next = 5;
                        return Object(__WEBPACK_IMPORTED_MODULE_5__encrypt__["d" /* encryptAesUuid */])();

                    case 5:
                        UserUuid = _context5.sent;
                        _context5.next = 8;
                        return Object(__WEBPACK_IMPORTED_MODULE_5__encrypt__["b" /* encryptAes */])(corvent(params));

                    case 8:
                        _context5.t0 = _context5.sent;
                        data = 'encryptionData=' + _context5.t0;
                        return _context5.abrupt('return', fetch(url, {
                            method: 'POST',
                            headers: {
                                'User-key': UserKey,
                                'User-uuid': UserUuid,
                                'Content-Type': 'application/x-www-form-urlencoded',
                                'Accept': 'application/json'
                            },
                            credentials: 'include',
                            mode: 'cors',
                            body: data
                        }).then(function (res) {
                            if (res.status >= 200 && res.status < 300) {
                                return res.json();
                            }
                            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(new Error(res.status));
                        }));

                    case 11:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, _this);
    }));

    return function _postEncrypt(_x6, _x7) {
        return _ref5.apply(this, arguments);
    };
}();

/**
 *  POST 敏感信息数据无需加密
 * @param {*} url
 * @param {*} params
 */
var _postNoEncryptAes = function () {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7(url, params) {
        var UserKey, UserUuid, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
            while (1) {
                switch (_context7.prev = _context7.next) {
                    case 0:
                        _context7.next = 2;
                        return Object(__WEBPACK_IMPORTED_MODULE_5__encrypt__["c" /* encryptAesKey */])();

                    case 2:
                        UserKey = _context7.sent;
                        _context7.next = 5;
                        return Object(__WEBPACK_IMPORTED_MODULE_5__encrypt__["d" /* encryptAesUuid */])();

                    case 5:
                        UserUuid = _context7.sent;
                        _context7.next = 8;
                        return Object(__WEBPACK_IMPORTED_MODULE_5__encrypt__["b" /* encryptAes */])(corventNoEncrypt(params));

                    case 8:
                        _context7.t0 = _context7.sent;
                        data = 'encryptionData=' + _context7.t0;
                        return _context7.abrupt('return', fetch(url, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                                'Accept': 'application/json',
                                'User-key': UserKey,
                                'User-uuid': UserUuid
                            },
                            credentials: 'include',
                            mode: 'cors',
                            body: data
                        }).then(function () {
                            var _ref7 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6(res) {
                                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                                    while (1) {
                                        switch (_context6.prev = _context6.next) {
                                            case 0:
                                                if (!(res.status >= 200 && res.status < 300)) {
                                                    _context6.next = 2;
                                                    break;
                                                }

                                                return _context6.abrupt('return', res.json());

                                            case 2:
                                                return _context6.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(new Error(res.status)));

                                            case 3:
                                            case 'end':
                                                return _context6.stop();
                                        }
                                    }
                                }, _callee6, _this);
                            }));

                            return function (_x10) {
                                return _ref7.apply(this, arguments);
                            };
                        }()));

                    case 11:
                    case 'end':
                        return _context7.stop();
                }
            }
        }, _callee7, _this);
    }));

    return function _postNoEncryptAes(_x8, _x9) {
        return _ref6.apply(this, arguments);
    };
}();

/**
 * post请求 -json 敏感信息
 * @param  {String} url    api地址
 * @param  {Object} params 包含post内容的object
 * @return {Promise}        Promise
 */
var _postJsonAes = function () {
    var _ref8 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9(url, params) {
        var UserKey, UserUuid, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
            while (1) {
                switch (_context9.prev = _context9.next) {
                    case 0:
                        _context9.next = 2;
                        return Object(__WEBPACK_IMPORTED_MODULE_5__encrypt__["c" /* encryptAesKey */])();

                    case 2:
                        UserKey = _context9.sent;
                        _context9.next = 5;
                        return Object(__WEBPACK_IMPORTED_MODULE_5__encrypt__["d" /* encryptAesUuid */])();

                    case 5:
                        UserUuid = _context9.sent;
                        _context9.next = 8;
                        return Object(__WEBPACK_IMPORTED_MODULE_5__encrypt__["b" /* encryptAes */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params));

                    case 8:
                        _context9.t0 = _context9.sent;
                        data = {
                            encryptionData: _context9.t0
                        };
                        return _context9.abrupt('return', fetch(url, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept': 'application/json',
                                'User-key': UserKey,
                                'User-uuid': UserUuid
                            },
                            credentials: 'include',
                            mode: 'cors',
                            body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)
                        }).then(function () {
                            var _ref9 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8(res) {
                                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                                    while (1) {
                                        switch (_context8.prev = _context8.next) {
                                            case 0:
                                                if (!(res.status >= 200 && res.status < 300)) {
                                                    _context8.next = 2;
                                                    break;
                                                }

                                                return _context8.abrupt('return', res.json());

                                            case 2:
                                                return _context8.abrupt('return', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(new Error(res.status)));

                                            case 3:
                                            case 'end':
                                                return _context8.stop();
                                        }
                                    }
                                }, _callee8, _this);
                            }));

                            return function (_x13) {
                                return _ref9.apply(this, arguments);
                            };
                        }()));

                    case 11:
                    case 'end':
                        return _context9.stop();
                }
            }
        }, _callee9, _this);
    }));

    return function _postJsonAes(_x11, _x12) {
        return _ref8.apply(this, arguments);
    };
}();

/**
 * get请求
 * @param  {String} options.url   api地址
 * @param  {String} options.query query参数
 * @return {Promise}               Promise
 */
var _get = function _get(url) {

    return fetch(url, {
        credentials: 'include'
    }).then(function (res) {
        if (res.status >= 200 && res.status < 300) {
            return res.json();
        }
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(new Error(res.status));
    });
};

var _postFile = function _postFile(url, formData) {
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        mode: 'no-cors',
        body: formData
    }).then(function (res) {
        if (res.status >= 200 && res.status < 300) {
            return res.json();
        }
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(new Error(res.status));
    });
};

/**
 * post请求，数据需要加密
 * @param  {String} url    api地址
 * @param  {Object} params 包含post内容的object
 * @return {Promise}        Promise
 */
var _post = function _post(url, params) {
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json'
        },
        credentials: 'include',
        mode: 'no-cors',
        body: corvent(params)
    }).then(function (res) {
        if (res.status >= 200 && res.status < 300) {
            return res.json();
        }
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(new Error(res.status));
    });
};

/**
 *  POST 数据无需加密
 * @param {*} url
 * @param {*} params
 */
var _postNoEncrypt = function _postNoEncrypt(url, params) {
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json'
        },
        credentials: 'include',
        mode: 'no-cors',
        body: corventNoEncrypt(params)
    }).then(function (res) {
        if (res.status >= 200 && res.status < 300) {
            return res.json();
        }
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(new Error(res.status));
    });
};

/**
 * post请求 -json
 * @param  {String} url    api地址
 * @param  {Object} params 包含post内容的object
 * @return {Promise}        Promise
 */
var _postJson = function _postJson(url, params) {

    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        credentials: 'include',
        mode: 'cors',
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)
    }).then(function (res) {
        if (res.status >= 200 && res.status < 300) {
            return res.json();
        }
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(new Error(res.status));
    });
};

function isString(str) {
    //判断是否为 String串
    return typeof str == 'string' && str.constructor == String;
}

/**
 * 转换json参数格式（加密）
 * @param params
 */
function corvent(params) {
    var result = '';
    if (params) {
        for (var jsonStr in params) {
            var value = params[jsonStr];
            result += jsonStr + '=' + value + '&';
        }
        if (result.length > 0) {
            result = result.substring(0, result.length - 1);
        }
    }
    var encryptResult = '';
    if (result) {
        //加密整个串
        encryptResult = Object(__WEBPACK_IMPORTED_MODULE_5__encrypt__["e" /* encryptAllRsa */])(result);
        if (encryptResult) {
            encryptResult = 'data=' + encryptResult;
        }
    }
    // console.log(1,'加密前数据为',JSON.stringify(params),2,'加密后数据为',encryptResult);
    return encryptResult;
}

/**
 *  转换参数不加密
 * @param {*} params
 */
function corventNoEncrypt(params) {
    var result = '';
    if (params) {
        for (var jsonStr in params) {
            result += jsonStr + '=' + params[jsonStr] + '&';
        }
        if (result.length > 0) {
            result = result.substring(0, result.length - 1);
        }
    }
    // console.log(result);
    return result;
}

/**
 * post请求，数据单独需要加密
 * @param  {String} url    api地址
 * @param  {Object} params 包含post内容的object
 * @return {Promise}        Promise
 */
var _postCors = function _postCors(url, params) {
    return fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        credentials: 'include',
        mode: 'cors',
        body: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params)
    }).then(function (res) {
        if (res.status >= 200 && res.status < 300) {
            return res.json();
        }
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(new Error(res.status));
    });
};

/***/ }),

/***/ "494y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4Vh3":
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ "6ZSt":
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ "8YCc":
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ "8x0Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return productConstants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return golbalConstants; });
/* unused harmony export golbalConstantsAPP */
var productConstants = {
    carId: 'd04876209b6a4087ae5b', //车险
    ygcxCardId: '0DBA04EAC3AE73681ED00DCFBDD85401', //阳光车险
    accountRiskId: '285bf02942434fccb4cd', //账户安全险
    healthId: 'b2637079b7744118b93f', //健康险
    gasId: 'f379499c7e6a4b029bd3', // 燃气
    pipelineId: 'adbfa4492ee641a4b41a', // 管道
    voltageId: 'c333d64b7a034edeae87', //电压
    womenId: 'AF735B7176AA262C63E6514C89058B8E',
    womenH5AppId: '559873267260CB044DE5563C936BD5E8',
    hkToulianId: '884132AB90B8BE2FC42A5FADCCAB696B',
    dhToulianId: '925D90242A8403E55F024C4CD539D0EC', //美利保-港股T+1
    giveZaId: 'BE615BC0F71742CEF7A546B7A5209702',
    zaEnjoyLifeId: 'FC20CF16F3771B8ADC870CF4BB98FAC0', //众安尊享一生id
    healthELifeId: 'DE72670708D28E3166218D001D8A104A',
    appLocalUrl: 'https://m-app.gomelife.com', //app线上
    platformType: '1',
    //carUrl: 'http://220.171.28.152:9080/wap/portal.do?url=Y0PkhmkFgFE6PKxd/EzxgA==', //车险测试
    carUrl: 'https://e.cic.cn/wap/portal.do?url=yu2hnObbpzbbFA9f--VvRg==', //车险线上
    costlyUrl: 'https://waptest.huaguilife.cn/hgcms/dock/dock_product!redirectProductUrl.action?DockOperator=guom&DockProduct=056601020&AgentCode=', //华贵重疾
    tlCategoryName: '投连险',
    ZAcarId: '2E948A6F10C9A8690B4DF140515797DE', //众安车险产品码
    CAcarId: 'CE77A1352A5166D3078B0BC8BC39990B',
    bhfxId: '3A6C29A0F9908CAABFBB729034888F6F',
    bhflyxId: 'AE3042B1E11389267DD3A3057A01D5A0',
    channelId: '149422702087422192',
    channelIdGuanWang: '115858317832623835',
    //三款中华非车险
    seriousInjuryId: '71A06700C9EF99E4799C9FFBE9D4EAAC',
    driveCarId: 'A8C5048AE249D06E418B3B247E14AA7B',
    rideCarId: '362983938E6D55C5FED52447B4E04735',
    studentSafeId: 'F6730F035E0F9E1882886ECAADB05CCC',

    activityId: '145390035611851716',
    activityBrokenScreenId: 'A4684C30F51D5B32027EBC0E1038BDA5',
    activityOfflineBrokenScreenId: 'C031D877817AA6DEDA6394EBC6A4758E',
    preventionId: '61D9D2BF120CB49269A3B1F88BC7225D', //防癌险
    buyPreventionId: '84A9C2CCB0F09B2D9424FE30A951EF22', //购买版防癌险

    followCarId: '21A557755289A7D94E30F184FD58473C', //随车行李险costlyDiseasesId
    penatesId: 'B1CFFA8BB0DB2C55A919F52E0DF6B2BE',
    accountRiskTwoId: 'E89396957D957F30048853D5AF0F46DC', //新的账户安全保
    voerseasMedicalId: 'FE2FD110F858B88E45C69BFFD40BAE91', // 海外医疗
    millionsMedicalId: '243C912E70CC963532A0C5744A76474E', //国美安康保
    educationMoney: 'C85C71D05B86C1DB7182190FBBC300DF', //国美宝贝未来年金
    steadysurplusId: '0596974D9E9ABDFF429CAB02AD78CA06', // 美富保-稳盈年金
    externalWelfareId: '509B500F4E0E230DFE6BF9FA599CC7F1', //国美金控内部福利产品
    internalWelfareId: '1643AFABA03CCE30B4CD85DBAE9056E8', //银盈通补充医疗
    groupInsuranceId: '3C4EB25A903AD8A3AD89EEC25078ABDD', //国美员工福利计划
    medicalInsurance: '7BC7F105BDDE3333EF5F3E165B6BA4AB', ////2019金控补充医疗

    zhonganyiliaoInsuranceId: 'B5FB8EDE8106B76D78B1AA8D9916983C', //众安补充医疗险
    leukaemiaBabyId: '1971E9F8296C8B2C3A1411A2DFDCBF6F', //信美宝贝(白血病)
    costlyDiseasesId: 'ACF5CBA5C6B55A4A79ED435F640E5E6B', //华贵人寿重疾险
    strichenDiseasesId: '690BE6FB171983E737901016F5D69BBA', //美泰保
    mommyBabyId: '5747F5BE2AEE012CA68E318A88591509', //妈咪宝贝
    insureTKId: 'C219682FFEC18D55324B8B5972911432', //泰康在线产品产品

    epidemicListId: '243215339D1AA6EE58B24B58AC9552E7', //国美员工关爱计划（抗击疫情）
    healthOnlineTkId: '39E8277B594AFCE508BC1B5294337499', //泰康在线健康有约产品
    kostaId: 'F3D24A19D77A09D49A302588C8ECFDC5', //众惠三高百万医疗产品
    beRelievedAX: '4261B3EC4338CC6BCC61BD798156537C', // 安心1号百万医疗产品
    medicalPingAnId: '30CF7B51FB351D5606D4F9C1A0F2B37A', // E生平安·医疗险
    productYccxId: 'E7CFFDDCA645607013FED129DA3AF1E8', //永诚财险  室内装修意外伤害财险
    productPuhuiId: '131842E36702E06644E19AFE00645E14',
    //新添加保险:长乐泰
    cltToulianId: '4A693F2288F118FCB9386A3A9A3C18BA',
    //新添加保险:鑫溢保
    xybToulianId: '56D42D7A607F3D418E8047D8256FDF35',

    //阳光赠险美途保
    giveYg: '229D9DA9E0899BCCD2C299E675B5AC88',
    //阳光赠险美健保（重疾）
    giveZj: 'E4FC2DC7D78D1B3511CD3DC277D7AB59',
    //新添加保险：中国人寿京康源
    jkyDiseasesId: '8E97219D733B3A85C3F263C20813636B'
};

if (false) {
    // 测试环境
    productConstants.healthVerify = 'http://test-mobile.health.pingan.com/ehis-hm/aitest/outindex.do';
} else {
    // 线上环境
    productConstants.healthVerify = 'https://mobile.health.pingan.com/ehis-hm/aitest/outindex.do';
}



var golbalConstants = {
    sourceTerminal: 1,
    agentSourceTerminal: 5,
    sellChannel: '115858317832623835'
};

/* app环境  全局配置 */
var golbalConstantsAPP = {
    sourceTerminal: 2,
    sellChannel: '115858317832623839',
    agentCompanyCode: 'gome_app'
};

/***/ }),

/***/ "E4LH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isNotEmpty; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dateformat__ = __webpack_require__("MQTS");
var _this = this;

/**
 * Created by admin on 2017/7/12.
 * 专门用于校验录入页参数
 */


function validate() {};

validate.getBirthDay = function (certificateNo) {
    if (/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(certificateNo)) {
        var birthday = certificateNo.substring(6, 14);
        if (birthday.length == 8) {
            birthday = birthday.substring(0, 4) + '-' + birthday.substring(4, 6) + '-' + birthday.substring(6, 8);
            return birthday;
        }
    }
};

var isNotEmpty = function isNotEmpty(str) {
    if (str !== '' && str !== null && typeof str !== 'undefined') {
        return true;
    }
    return false;
};
/**
 * 证件类型枚举
 * @type {{ID_CARD_NO: string, PASSPORT: string, OFFICER_CERTIFICATE: string}}
 */
validate.cardType = {
    ID_CARD_NO: '1', //身份证
    PASSPORT: '2', // 护照
    OFFICER_CERTIFICATE: '3' // 军官证
};

validate.addressType = {
    NORMAL: '1', //平常
    STRICT: '2' //严格
};

/**
 * 校验是否为姓名格式  中文 2-5 英文 2-30
 * @param name
 */
validate.isName = function (name) {
    if (!isNotEmpty(name)) {
        return false;
    }
    var regx = /^[\u4e00-\u9fa5]{2,5}$|^[a-zA-Z]{2,30}$/gi;
    if (regx.test(name)) {
        return true;
    }
    return false;
};

validate.isCertificateNo = function (certificateNo) {
    //15位和18位身份证号码的正则表达式
    var regIdCard = /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
    //如果通过该验证，说明身份证格式正确，但准确性还需计算
    if (regIdCard.test(certificateNo)) {
        if (certificateNo.length == 18) {
            var idCardWi = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2); //将前17位加权因子保存在数组里
            var idCardY = new Array(1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2); //这是除以11后，可能产生的11位余数、验证码，也保存成数组
            var idCardWiSum = 0; //用来保存前17位各自乖以加权因子后的总和
            for (var i = 0; i < 17; i++) {
                idCardWiSum += certificateNo.substring(i, i + 1) * idCardWi[i];
            }
            var idCardMod = idCardWiSum % 11; //计算出校验码所在数组的位置
            var idCardLast = certificateNo.substring(17); //得到最后一位身份证号码
            //如果等于2，则说明校验码是10，身份证号码最后一位应该是X
            if (idCardMod == 2) {
                if (idCardLast == 'X' || idCardLast == 'x') {
                    return true;
                } else {
                    return false;
                }
            } else {
                //用计算出的验证码与最后一位身份证号码匹配，如果一致，说明通过，否则是无效的身份证号码
                if (idCardLast == idCardY[idCardMod]) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    } else {
        return false;
    }
},

/**
 * 证件类型校验，默认为身份证
 * @param cardNo
 * @param type
 */
validate.isCardNo = function (cardNo) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : cardType.ID_CARD_NO;

    if (!isNotEmpty(cardNo)) {
        return false;
    }
    var flag = false;
    var regx = '';
    switch (type) {
        default:
            //默认为身份证号正则
            flag = _this.isCertificateNo(cardNo);
            break;
    }
    return flag;
};

/**
 * 校验年龄是否在某个区间内
 * @param birthday
 * @param ageNumStart
 * @param ageNumEnd
 * @param sureDateNum
 */
validate.isAgeRange = function (birthday, ageNumStart, ageNumEnd) {
    var sureDateNum = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    if (!isNotEmpty(birthday)) {
        return false;
    }
    var result = birthday.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/);
    if (result != null) {
        var birthdayStr = birthday.replace(/-/g, '/') + ' 00:00:00';
        var dd = new Date(birthdayStr);
        var startTime = __WEBPACK_IMPORTED_MODULE_0__dateformat__["a" /* default */].getDateStart(__WEBPACK_IMPORTED_MODULE_0__dateformat__["a" /* default */].addDay(new Date(), sureDateNum));
        dd = __WEBPACK_IMPORTED_MODULE_0__dateformat__["a" /* default */].addDay(dd, ageNumStart); //大于ageNumStart天
        if (dd.getTime() > startTime.getTime()) {
            //
            return false;
        }
        dd = __WEBPACK_IMPORTED_MODULE_0__dateformat__["a" /* default */].addDay(dd, -ageNumStart);
        dd = __WEBPACK_IMPORTED_MODULE_0__dateformat__["a" /* default */].addYear(dd, ageNumEnd + 1); //加一岁，因为max 有一年的期限
        if (dd.getTime() < startTime.getTime()) {
            return false;
        }
    }
};

/**
 * 校验是否为正常日期
 * @param time
 * @returns {*}
 */
validate.isDate = function (time) {
    if (!isNotEmpty(time)) {
        return false;
    }
    if (time == '' || typeof time == 'undefined' || time.length != 10) {
        return false;
    }
    var date = time;
    var result = date.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/);
    if (result == null) {
        return false;
    }
    var d = new Date(result[1], result[3] - 1, result[4]);
    var now = new Date();
    if (d.getTime() > now.getTime()) {
        // console.log(d.getTime());
        return false;
    }
    return d.getFullYear() == result[1] && d.getFullYear() && d.getMonth() + 1 == result[3] && d.getDate() == result[4];
};

/**
 * 是否为正确的手机号
 * @param mobile
 */
validate.isMobile = function (mobile) {
    if (!isNotEmpty(mobile)) {
        return false;
    }
    var reg = /(^(1[3-9]\d{9})$)/;
    if (reg.test(mobile)) {
        return true;
    }
    return false;
};

/**
 * 校验邮箱
 * @param email
 * @returns {boolean}
 */
validate.isEmail = function (email) {
    if (!isNotEmpty(email)) {
        return false;
    }
    var reg = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;
    if (reg.test(email)) {
        if (email.length <= 50) {
            return true;
        }
    }
    return false;
};

/**
 * 校验地址
 * @param address
 * @returns {boolean}
 */
validate.isAddress = function (address) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : validate.addressType.NORMAL;

    if (!isNotEmpty(address)) {
        return false;
    }
    if (address.length < 125) {
        if (type == validate.addressType.STRICT) {
            //严格模式,含有街道，
            var reg = /[乡|镇|苏木|村|庄|组|屯|街|道|路|胡同|弄|号|楼|座|栋|幢|里|排|室|层|房|门|院|单元|厦|广场|中心]+/g;
            if (reg.test(address) && address.length >= 4) {
                return true;
            } else {
                return false;
            }
        } else {
            if (sessionStorage['buyProductId'] == '5747F5BE2AEE012CA68E318A88591509') {
                if (address.length >= 6 && address.length <= 50) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        }
    }
    return false;
};

/**
 * 校验银行卡号规则
 * @param bankNum
 * @returns {bankNum}
 */
validate.isBankCard = function (bankno) {
    if (!isNotEmpty(bankno)) {
        return false;
    }
    var lastNum = bankno.substr(bankno.length - 1, 1); //取出最后一位（与luhm进行比较）
    var first15Num = bankno.substr(0, bankno.length - 1); //前15或18位
    var newArr = new Array();
    for (var i = first15Num.length - 1; i > -1; i--) {
        //前15或18位倒序存进数组
        newArr.push(first15Num.substr(i, 1));
    }
    var arrJiShu = new Array(); //奇数位*2的积 <9
    var arrJiShu2 = new Array(); //奇数位*2的积 >9

    var arrOuShu = new Array(); //偶数位数组
    for (var j = 0; j < newArr.length; j++) {
        if ((j + 1) % 2 == 1) {
            //奇数位
            if (parseInt(newArr[j]) * 2 < 9) {
                arrJiShu.push(parseInt(newArr[j]) * 2);
            } else {
                arrJiShu2.push(parseInt(newArr[j]) * 2);
            }
        } else {
            //偶数位
            arrOuShu.push(newArr[j]);
        }
    }

    var jishuChild1 = new Array(); //奇数位*2 >9 的分割之后的数组个位数
    var jishuChild2 = new Array(); //奇数位*2 >9 的分割之后的数组十位数
    for (var h = 0; h < arrJiShu2.length; h++) {
        jishuChild1.push(parseInt(arrJiShu2[h]) % 10);
        jishuChild2.push(parseInt(arrJiShu2[h]) / 10);
    }

    var sumJiShu = 0; //奇数位*2 < 9 的数组之和
    var sumOuShu = 0; //偶数位数组之和
    var sumJiShuChild1 = 0; //奇数位*2 >9 的分割之后的数组个位数之和
    var sumJiShuChild2 = 0; //奇数位*2 >9 的分割之后的数组十位数之和
    var sumTotal = 0;
    for (var m = 0; m < arrJiShu.length; m++) {
        sumJiShu = sumJiShu + parseInt(arrJiShu[m]);
    }

    for (var n = 0; n < arrOuShu.length; n++) {
        sumOuShu = sumOuShu + parseInt(arrOuShu[n]);
    }

    for (var p = 0; p < jishuChild1.length; p++) {
        sumJiShuChild1 = sumJiShuChild1 + parseInt(jishuChild1[p]);
        sumJiShuChild2 = sumJiShuChild2 + parseInt(jishuChild2[p]);
    }
    //计算总和
    sumTotal = parseInt(sumJiShu) + parseInt(sumOuShu) + parseInt(sumJiShuChild1) + parseInt(sumJiShuChild2);

    //计算Luhm值
    var k = parseInt(sumTotal) % 10 == 0 ? 10 : parseInt(sumTotal) % 10;
    var luhm = 10 - k;
    if (lastNum == luhm) {
        return true;
    } else {
        return false;
    }
};

/**
 * 校验邮政编码规则
 * @param zipCode
 * @returns {zipCode}
*/
validate.isZipCode = function (zipCode) {
    if (!isNotEmpty(zipCode)) {
        return false;
    }
    //邮政编码   第一位不为0  /^[0-9]\d{5}$/
    //
    var reg = /[0-9]\d{5}(?!\d)/;
    if (!reg.test(zipCode)) {
        return false;
    } else if (reg.test(zipCode) && zipCode.length > 6) {
        return false;
    }
    return true;
};
/**
 * 校验密码规则
 * @param password
 * @returns {boolean}
 */
validate.isPassword = function (password) {
    if (!isNotEmpty(password)) {
        return false;
    }
    var regx = /^[a-z\d]*$/i;
    var allNumber = /^\d*$/;
    var allLetter = /^[a-z]*$/i;
    /* if(password.length > 20 || password.length < 6){
        return false;
    }else if(allNumber.test(password) || allLetter.test(password)){
        return false;
    }else if(!regx.test(password)){
        return false;
    }*/
    if (password.length > 20 || password.length < 6) {
        return false;
    } else if (allNumber.test(password) || allLetter.test(password)) {
        return false;
    }
    return true;
};

/**
 * 校验图片验证码
 * @param imgCode
 * @returns {boolean}
 */
validate.isImgCode = function (imgCode) {
    if (!isNotEmpty(imgCode)) {
        return false;
    }
    if (imgCode.length == 4) {
        return true;
    }
    return false;
};

/**
 * 校验短信验证码
 * @param smsCode
 * @returns {boolean}
 */
validate.isSmsCode = function (smsCode) {
    if (!isNotEmpty(smsCode)) {
        return false;
    }
    var regx = /^\d{6}$/;
    if (regx.test(smsCode)) {
        return true;
    }
    return false;
};
// 校验姓和名
validate.isSnameCode = function (smsCode) {
    if (!isNotEmpty(smsCode)) {
        return false;
    }
    var regx = /^[a-zA-Z]{1,100}$/;
    if (regx.test(smsCode)) {
        return true;
    }
    return false;
};
validate.isNumberCode = function (smsCode) {
    if (!isNotEmpty(smsCode)) {
        return false;
    }
    var regx = /^\d+(\.\d*)?$/;
    if (regx.test(smsCode)) {
        if (smsCode.length - 1 >= 10) {
            return false;
        }
        return true;
    }
    return false;
};

/**
 * 员工号
 * @param employeeID
 * @returns {boolean}
 */
validate.isEmployeeID = function (employeeID) {
    if (!isNotEmpty(employeeID)) {
        return false;
    }
    return true;
};

/**
 * 封装校验方法
 */
validate.checkParam = function (type, value, addressType) {
    var flag = true;
    if (type && value !== '') {
        switch (type) {
            // case 'bankAddress' :
            //     flag = validate.isbankAddress(value);
            case 'bankCard':
                flag = validate.isBankCard(value);
                break;
            case 'zipCode':
                flag = validate.isZipCode(value);
                break;
            case 'mobile':
                flag = validate.isMobile(value);
                break;
            case 'password':
                flag = validate.isPassword(value);
                break;
            case 'name':
                flag = validate.isName(value);
                break;
            case 'employeeID':
                //国美员工号
                flag = validate.isEmployeeID(value);
                break;
            case 'certificateNo':
                flag = validate.isCertificateNo(value);
                break;
            case 'email':
                flag = validate.isEmail(value);
                break;
            case 'address':
                flag = validate.isAddress(value, addressType);
                break;
            case 'surname':
                flag = validate.isSnameCode(value);
                break;
            case 'forename':
                flag = validate.isSnameCode(value);
                break;
            case 'salary':
                flag = validate.isNumberCode(value);
                break;
        }
    }
    return flag;
};

// 检测性别 1 为男 2 为女
validate.checkSex = function (idCard) {
    var lastStr = idCard.slice(16, -1);
    // console.log('性别：', lastStr);
    if (lastStr % 2 === 0) {
        return 2;
    } else {
        return 1;
    }
};

/**
 * 封装校验方法
 */
validate.checkParamWithMsg = function (type, value, name, addressType) {
    if (value == '') {
        return name + '不能为空';
    }
    var flag = validate.checkParam(type, value, addressType);
    if (!flag) {
        return '请输入正确的' + name;
    }
    return '';
};

/**
 * 封装校验方法
 */
validate.checkParamInsured = function (name, showName, value, compType, addressType) {
    var msg = compType == 1 ? '投保人' : compType == 2 ? '被保人' : compType == 8 ? '续期账户信息' : compType;
    if (value == '' || value == undefined) {
        return msg + showName + '不能为空';
    }
    var flag = validate.checkParam(name, value, addressType);
    if (!flag) {
        return '请输入正确的' + msg + showName;
    }
    return '';
};

validate.checkBirthdayIsOk = function (birthday, ageNumStart, ageNumEnd) {
    var sureDateNum = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var compType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    //检验年龄范围
    var compTypeName = compType == 1 ? '投保人' : compType == 2 ? '被保人' : '';
    var checkParamsError = '';
    // let result = birthday.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/);
    // console.log(22222,result);
    // if(result != null){
    //     let birthdayStr = birthday.replace(/-/g,'/') + ' 00:00:00';
    //     console.log('birthdayStr:' + birthdayStr);
    //     let dd = new Date(birthdayStr);
    //     let startTime = dateformat.getDateStart(dateformat.addDay(new Date() , sureDateNum));
    //     dd = dateformat.addYear(dd, ageNumStart); //大于十八岁
    //     if(dd.getTime() > startTime.getTime()){//
    //         checkParamsError = '请保证' + compTypeName + '年龄在'+ ageNumStart +'岁~'+ ageNumEnd +'岁';
    //     }
    //     dd = dateformat.addYear(dd, -ageNumStart);
    //     dd = dateformat.addYear(dd, ageNumEnd + 1); //加一岁，因为max 有一年的期限
    //     console.log('时间戳：' + dd.getTime() + ',' + startTime.getTime());
    //     if(dd.getTime() < startTime.getTime()){
    //         checkParamsError = '请保证' + compTypeName + '年龄在'+ ageNumStart +'岁~'+ ageNumEnd +'岁';
    //     }
    // }
    // return checkParamsError;
    // console.log(birthday,565756757);

    var birthYear = Number(birthday.split('-')[0]);
    var birthMounth = Number(birthday.split('-')[1]);
    var birthDate = Number(birthday.split('-')[2]);
    var year = Number(new Date().getFullYear());
    var month = Number(new Date().getMonth() + 1);
    var day = Number(new Date().getDate());
    if (year - birthYear > ageNumStart) {
        if (year - birthYear === ageNumEnd) {
            if (month < birthMounth) {
                //过了
            } else if (birthMounth === month) {
                if (birthDate >= day) {
                    //过了
                } else {
                    checkParamsError = '请保证' + compTypeName + '年龄在' + ageNumStart + '岁~' + ageNumEnd + '岁';
                }
            } else {
                checkParamsError = '请保证' + compTypeName + '年龄在' + ageNumStart + '岁~' + ageNumEnd + '岁';
            }
        }
        //过了
        return checkParamsError;
    } else if (year - birthYear === ageNumStart) {
        if (month - birthMounth > 0) {
            //过了
        } else if (month - birthMounth === 0) {
            if (day - birthDate >= 0) {
                //过了
            } else {
                checkParamsError = '请保证' + compTypeName + '年龄在' + ageNumStart + '岁~' + ageNumEnd + '岁';
            }
        } else {
            checkParamsError = '请保证' + compTypeName + '年龄在' + ageNumStart + '岁~' + ageNumEnd + '岁';
        }
        return checkParamsError;
    } else {
        checkParamsError = '请保证' + compTypeName + '年龄在' + ageNumStart + '岁~' + ageNumEnd + '岁';
        return checkParamsError;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (validate);

/***/ }),

/***/ "FJ1s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getwechatConfig */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return wechatLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return wechatOpenid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return wechatUnionId; });
/* unused harmony export getShareProductInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_http__ = __webpack_require__("3pLw");


var getwechatConfig = function getwechatConfig(wxUrl) {
    var url = '/insurance-web/weixin/js/wxconfig';
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_http__["h" /* _postNoEncrypt */])(url, {
        'url': wxUrl
    });
};

//授权登录
var wechatLogin = function wechatLogin(code) {
    var url = '/insurance-web/wechatLogin';
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_http__["c" /* _post */])(url, {
        'code': code
    });
};

//openId

var wechatOpenid = function wechatOpenid(code) {
    var url = '/insurance-web/insertOpenid';
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_http__["c" /* _post */])(url, {
        'code': code
    });
};

//UnionId

var wechatUnionId = function wechatUnionId(code) {
    var url = '/insurance-web/insertUnionId';
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_http__["c" /* _post */])(url, {
        'code': code
    });
};

/**
 * 二维码获取产品信息
 *
 */
var getShareProductInfo = function getShareProductInfo(productCode) {
    var url = '/insurance-web/product/getShareProductInfo?productCode=' + productCode;
    return Object(__WEBPACK_IMPORTED_MODULE_0__utils_http__["a" /* _get */])(url);
};

/***/ }),

/***/ "GTtm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{staticClass:"router-view"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KYqO":
/***/ (function(module, exports) {

module.exports = {"_args":[["elliptic@6.4.0","/data/file/jenkins_home/workspace/GomeLife-Prod_gmjr-bx-h5"]],"_from":"elliptic@6.4.0","_id":"elliptic@6.4.0","_inBundle":false,"_integrity":"sha1-ysmvh2LIWDYYcAPI3+GT5eLq5d8=","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.4.0","name":"elliptic","escapedName":"elliptic","rawSpec":"6.4.0","saveSpec":null,"fetchSpec":"6.4.0"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"http://registry.npm.taobao.org/elliptic/download/elliptic-6.4.0.tgz","_spec":"6.4.0","_where":"/data/file/jenkins_home/workspace/GomeLife-Prod_gmjr-bx-h5","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.4.0"}

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ba51cb6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("GTtm");
function injectStyle (ssrContext) {
  __webpack_require__("cK6X")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ba51cb6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M9A7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return checkMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return register; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return sendSms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return userMobileVerify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return userSetPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return smsSend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return userRegisterService; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return userLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return smsCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return userUpdatePassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return checkSmsVerifiCode; });
/* unused harmony export checkImgVerifiCode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return loginOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return forgotSmsSend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return resetPwd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bindAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return tokenChangeLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return tokenLoginChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isMaster; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getSessionByToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getFullPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return sendPlusSms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return plusBindMobile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_http__ = __webpack_require__("3pLw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_encrypt__ = __webpack_require__("aNLv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_storage__ = __webpack_require__("VKKs");




var _this = this;

/**
 * Created by admin on 2017/1/19.
 */




var checkMobile = function checkMobile(mobile) {
    // console.log(' mobile= ' + mobile);
    var url = '/insurance-web/users/userMobileVerify';
    return Object(__WEBPACK_IMPORTED_MODULE_3__utils_http__["c" /* _post */])(url, { 'mobile': mobile });
};

var register = function register(mobile, password, smsCode, inviteId, activityName) {
    // console.log('注册成功');
    var url = '/insurance-web/users/userRegisterService';
    var invite = sessionStorage.getItem('gatewayInviteCode');
    var channelCode = sessionStorage.getItem('channelCode');
    if (invite) {
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            Object(__WEBPACK_IMPORTED_MODULE_3__utils_http__["i" /* _postNoEncryptAes */])(url, {
                'mobile': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(mobile),
                'password': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(password),
                'code': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(smsCode),
                'inviteId': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(inviteId),
                'inviteCode': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(invite),
                'channelCode': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(channelCode),
                'activity': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(activityName)
            }).then(function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    _context.t0 = JSON;
                                    _context.next = 3;
                                    return Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["a" /* decryptAes */])(res.encryptionData);

                                case 3:
                                    _context.t1 = _context.sent;
                                    res = _context.t0.parse.call(_context.t0, _context.t1);

                                    resolve(res);

                                case 6:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this);
                }));

                return function (_x) {
                    return _ref.apply(this, arguments);
                };
            }()).catch(reject);
        });
    } else {
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            Object(__WEBPACK_IMPORTED_MODULE_3__utils_http__["i" /* _postNoEncryptAes */])(url, {
                'mobile': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(mobile),
                'password': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(password),
                'code': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(smsCode),
                'inviteId': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(inviteId),
                'channelCode': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(channelCode),
                'activity': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(activityName)
            }).then(function () {
                var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(res) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                                case 0:
                                    _context2.t0 = JSON;
                                    _context2.next = 3;
                                    return Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["a" /* decryptAes */])(res.encryptionData);

                                case 3:
                                    _context2.t1 = _context2.sent;
                                    res = _context2.t0.parse.call(_context2.t0, _context2.t1);

                                    resolve(res);

                                case 6:
                                case 'end':
                                    return _context2.stop();
                            }
                        }
                    }, _callee2, _this);
                }));

                return function (_x2) {
                    return _ref2.apply(this, arguments);
                };
            }()).catch(reject);
        });
    }
};

var login = function login(mobile, password, isRadioed, activityId) {
    var loginType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '1';

    var url = '/insurance-web/users/userLogin';
    var invite = sessionStorage.getItem('gatewayInviteCode');
    var channelCode = sessionStorage.getItem('channelCode');
    if (isRadioed && typeof isRadioed != 'undefined') {
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            Object(__WEBPACK_IMPORTED_MODULE_3__utils_http__["i" /* _postNoEncryptAes */])(url, {
                'mobile': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(mobile),
                'password': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(password),
                'isAuthorized': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])('Y'),
                'inviteCode': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(invite),
                'channelCode': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(channelCode),
                'activity': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(activityId),
                'loginType': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(loginType)
            }).then(function () {
                var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(res) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                                case 0:
                                    _context3.t0 = JSON;
                                    _context3.next = 3;
                                    return Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["a" /* decryptAes */])(res.encryptionData);

                                case 3:
                                    _context3.t1 = _context3.sent;
                                    res = _context3.t0.parse.call(_context3.t0, _context3.t1);

                                    resolve(res);

                                case 6:
                                case 'end':
                                    return _context3.stop();
                            }
                        }
                    }, _callee3, _this);
                }));

                return function (_x4) {
                    return _ref3.apply(this, arguments);
                };
            }()).catch(reject);
        });
    } else {
        return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            Object(__WEBPACK_IMPORTED_MODULE_3__utils_http__["i" /* _postNoEncryptAes */])(url, {
                'mobile': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(mobile),
                'password': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(password),
                'inviteCode': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(invite),
                'channelCode': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(channelCode),
                'activity': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(activityId),
                'loginType': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(loginType)
            }).then(function () {
                var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(res) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                        while (1) {
                            switch (_context4.prev = _context4.next) {
                                case 0:
                                    _context4.t0 = JSON;
                                    _context4.next = 3;
                                    return Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["a" /* decryptAes */])(res.encryptionData);

                                case 3:
                                    _context4.t1 = _context4.sent;
                                    res = _context4.t0.parse.call(_context4.t0, _context4.t1);

                                    resolve(res);

                                case 6:
                                case 'end':
                                    return _context4.stop();
                            }
                        }
                    }, _callee4, _this);
                }));

                return function (_x5) {
                    return _ref4.apply(this, arguments);
                };
            }()).catch(reject);
        });
    }
};

var sendSms = function sendSms(mobile, type, imgCode) {
    var url = '/insurance-web/captcha/smsSend';
    return Object(__WEBPACK_IMPORTED_MODULE_3__utils_http__["c" /* _post */])(url, { 'phone': mobile, 'function': type, 'captchaReceived': imgCode });
};

// 手机号验证是否注册
var userMobileVerify = function userMobileVerify(mobile) {
    var url = '/insurance-web/users/userMobileVerify';
    return Object(__WEBPACK_IMPORTED_MODULE_3__utils_http__["c" /* _post */])(url, { 'mobile': mobile });
};
// 设置密码/忘记密码
var userSetPassword = function userSetPassword(_ref5) {
    var mobile = _ref5.mobile,
        newPassword = _ref5.newPassword,
        type = _ref5.type,
        smsCode = _ref5.smsCode,
        requestToken = _ref5.requestToken;

    var url = '/insurance-web/users/userSetPassword';
    // return _postJson(url, { 'mobile': mobile, 'newPassword': newPassword, 'type': type, 'smsCode': smsCode, 'requestToken': requestToken });
    return Object(__WEBPACK_IMPORTED_MODULE_3__utils_http__["h" /* _postNoEncrypt */])(url, {
        'mobile': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(mobile),
        'newPassword': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(newPassword),
        'type': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(type),
        'requestToken': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(requestToken)
    });
};
//获取短信验证码
var smsSend = function smsSend(mobile, type, imgCode) {
    var url = '/insurance-web/users/smsSend';
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_http__["d" /* _postAes */])(url, { 'mobile': mobile, 'type': type, 'imgCode': imgCode }).then(function () {
            var _ref6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(res) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.t0 = JSON;
                                _context5.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["a" /* decryptAes */])(res.encryptionData);

                            case 3:
                                _context5.t1 = _context5.sent;
                                res = _context5.t0.parse.call(_context5.t0, _context5.t1);

                                resolve(res);

                            case 6:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this);
            }));

            return function (_x6) {
                return _ref6.apply(this, arguments);
            };
        }()).catch(reject);
    });
};
// 短信验证码注册
var userRegisterService = function userRegisterService(_ref7) {
    var mobile = _ref7.mobile,
        _ref7$inviteId = _ref7.inviteId,
        inviteId = _ref7$inviteId === undefined ? '' : _ref7$inviteId,
        _ref7$invitePassUserI = _ref7.invitePassUserId,
        invitePassUserId = _ref7$invitePassUserI === undefined ? '' : _ref7$invitePassUserI,
        _ref7$inviteUserMobil = _ref7.inviteUserMobile,
        inviteUserMobile = _ref7$inviteUserMobil === undefined ? '' : _ref7$inviteUserMobil,
        _ref7$inviteCode = _ref7.inviteCode,
        inviteCode = _ref7$inviteCode === undefined ? '' : _ref7$inviteCode,
        _ref7$channelCode = _ref7.channelCode,
        channelCode = _ref7$channelCode === undefined ? '' : _ref7$channelCode,
        _ref7$activity = _ref7.activity,
        activity = _ref7$activity === undefined ? '' : _ref7$activity,
        smsCode = _ref7.smsCode,
        requestToken = _ref7.requestToken;

    var url = '/insurance-web/users/userRegisterService';
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_http__["i" /* _postNoEncryptAes */])(url, {
            'mobile': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(mobile),
            'inviteId': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(inviteId),
            'invitePassUserId': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(invitePassUserId),
            'inviteUserMobile': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(inviteUserMobile),
            'inviteCode': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(inviteCode),
            'channelCode': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(channelCode),
            'activity': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(activity),
            'smsCode': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(smsCode),
            'requestToken': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(requestToken)
        }).then(function () {
            var _ref8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(res) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.t0 = JSON;
                                _context6.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["a" /* decryptAes */])(res.encryptionData);

                            case 3:
                                _context6.t1 = _context6.sent;
                                res = _context6.t0.parse.call(_context6.t0, _context6.t1);

                                resolve(res);

                            case 6:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this);
            }));

            return function (_x7) {
                return _ref8.apply(this, arguments);
            };
        }()).catch(reject);
    });
};
//用户登陆
var userLogin = function userLogin(_ref9) {
    var mobile = _ref9.mobile,
        _ref9$password = _ref9.password,
        password = _ref9$password === undefined ? '' : _ref9$password,
        _ref9$isAuthorized = _ref9.isAuthorized,
        isAuthorized = _ref9$isAuthorized === undefined ? 'N' : _ref9$isAuthorized,
        _ref9$invitePassUserI = _ref9.invitePassUserId,
        invitePassUserId = _ref9$invitePassUserI === undefined ? '' : _ref9$invitePassUserI,
        _ref9$inviteUserMobil = _ref9.inviteUserMobile,
        inviteUserMobile = _ref9$inviteUserMobil === undefined ? '' : _ref9$inviteUserMobil,
        _ref9$inviteUserCente = _ref9.inviteUserCenterId,
        inviteUserCenterId = _ref9$inviteUserCente === undefined ? '' : _ref9$inviteUserCente,
        _ref9$inviteUserChann = _ref9.inviteUserChannel,
        inviteUserChannel = _ref9$inviteUserChann === undefined ? '' : _ref9$inviteUserChann,
        _ref9$inviteCode = _ref9.inviteCode,
        inviteCode = _ref9$inviteCode === undefined ? '' : _ref9$inviteCode,
        _ref9$channelCode = _ref9.channelCode,
        channelCode = _ref9$channelCode === undefined ? '' : _ref9$channelCode,
        _ref9$activity = _ref9.activity,
        activity = _ref9$activity === undefined ? '' : _ref9$activity,
        loginType = _ref9.loginType,
        _ref9$smsCode = _ref9.smsCode,
        smsCode = _ref9$smsCode === undefined ? '' : _ref9$smsCode,
        _ref9$requestToken = _ref9.requestToken,
        requestToken = _ref9$requestToken === undefined ? '' : _ref9$requestToken;

    var url = '/insurance-web/users/userLogin';
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_http__["i" /* _postNoEncryptAes */])(url, {
            'mobile': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(mobile),
            'password': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(password),
            'isAuthorized': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(isAuthorized),
            'invitePassUserId': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(invitePassUserId),
            'inviteUserMobile': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(inviteUserMobile),
            'inviteUserCenterId': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(inviteUserCenterId),
            'inviteUserChannel': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(inviteUserChannel),
            'inviteCode': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(inviteCode),
            'channelCode': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(channelCode),
            'activity': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(activity),
            'loginType': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(loginType),
            'smsCode': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(smsCode),
            'requestToken': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(requestToken)
        }).then(function () {
            var _ref10 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(res) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.t0 = JSON;
                                _context7.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["a" /* decryptAes */])(res.encryptionData);

                            case 3:
                                _context7.t1 = _context7.sent;
                                res = _context7.t0.parse.call(_context7.t0, _context7.t1);

                                resolve(res);

                            case 6:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this);
            }));

            return function (_x8) {
                return _ref10.apply(this, arguments);
            };
        }()).catch(reject);
    });
};

//短信验证码校验
var smsCheck = function smsCheck(_ref11) {
    var mobile = _ref11.mobile,
        smsCode = _ref11.smsCode,
        type = _ref11.type,
        requestToken = _ref11.requestToken;

    var url = '/insurance-web/users/smsCheck';
    return Object(__WEBPACK_IMPORTED_MODULE_3__utils_http__["c" /* _post */])(url, { 'mobile': mobile, 'type': type, 'smsCode': smsCode, 'requestToken': requestToken });
};
//修改密码
var userUpdatePassword = function userUpdatePassword(_ref12) {
    var mobile = _ref12.mobile,
        newPassword = _ref12.newPassword,
        type = _ref12.type,
        requestToken = _ref12.requestToken;

    var url = '/insurance-web/users/userUpdatePassword';
    return Object(__WEBPACK_IMPORTED_MODULE_3__utils_http__["h" /* _postNoEncrypt */])(url, {
        'mobile': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(mobile),
        'type': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(type),
        'newPassword': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(newPassword),
        'requestToken': Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["e" /* encryptAllRsa */])(requestToken)
    });
};

var checkSmsVerifiCode = function checkSmsVerifiCode(mobile, smsVerifiCode, type) {
    // console.log('检验短信验证码');
    var url = '/insurance-web/captcha/smsCheck';
    return Object(__WEBPACK_IMPORTED_MODULE_3__utils_http__["c" /* _post */])(url, { 'phone': mobile, 'code': smsVerifiCode, 'function': type });
};

var checkImgVerifiCode = function checkImgVerifiCode(mobile, imgVerifiCode) {
    // console.log('检验图片验证码');
    var url = '/insurance-web/captcha/captchaImgCheck';
    return Object(__WEBPACK_IMPORTED_MODULE_3__utils_http__["c" /* _post */])(url, { 'captchaReceived': imgVerifiCode, 'phone': mobile });
};

var loginOut = function loginOut() {
    var url = '/insurance-web/users/userLoginOut';
    return Object(__WEBPACK_IMPORTED_MODULE_3__utils_http__["a" /* _get */])(url);
};

var forgotSmsSend = function forgotSmsSend(mobile, imgCode) {
    var url = '/insurance-web/users/userPasswordResetGetCode';
    return Object(__WEBPACK_IMPORTED_MODULE_3__utils_http__["c" /* _post */])(url, { 'mobile': mobile, 'captchaReceived': imgCode });
};

var resetPwd = function resetPwd(mobile, verifyCode, newPassword) {
    var url = '/insurance-web/users/userPasswordReset';
    return Object(__WEBPACK_IMPORTED_MODULE_3__utils_http__["c" /* _post */])(url, { 'mobile': mobile, 'verifyCode': verifyCode, 'newPassword': newPassword });
};

var isLogin = function isLogin() {
    var url = '/insurance-web/users/getUser';
    return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_http__["d" /* _postAes */])(url).then(function () {
            var _ref13 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(res) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.t0 = JSON;
                                _context8.next = 3;
                                return Object(__WEBPACK_IMPORTED_MODULE_4__utils_encrypt__["a" /* decryptAes */])(res.encryptionData);

                            case 3:
                                _context8.t1 = _context8.sent;
                                res = _context8.t0.parse.call(_context8.t0, _context8.t1);

                                if (res.success) {
                                    // alert(res.data.accessToken);
                                    if (res.data.idStr) {
                                        __WEBPACK_IMPORTED_MODULE_5__utils_storage__["a" /* default */].setL('inviterOwn', res.data.idStr);
                                        __WEBPACK_IMPORTED_MODULE_5__utils_storage__["a" /* default */].set('inviterOwn', res.data.idStr);
                                    } else {
                                        localStorage.removeItem('inviterOwn');
                                        sessionStorage.removeItem('inviterOwn');
                                    }
                                    if (res.data.accessToken) {
                                        sessionStorage['accessToken'] = res.data.accessToken;
                                    }
                                }
                                resolve(res);

                            case 7:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this);
            }));

            return function (_x9) {
                return _ref13.apply(this, arguments);
            };
        }()).catch(reject);
    });
};

var bindAccount = function bindAccount(mobile, code) {
    var url = '/insurance-web/users/userBindApi';
    return Object(__WEBPACK_IMPORTED_MODULE_3__utils_http__["c" /* _post */])(url, { 'mobile': mobile, 'code': code });
};

//代理人token 置换 登录态
var tokenChangeLogin = function tokenChangeLogin(token) {
    var url = '/insurance-web/users/replaceToken';
    return Object(__WEBPACK_IMPORTED_MODULE_3__utils_http__["c" /* _post */])(url, { 'token': token });
};

// 从美云宝跳转过来置换 token
// export const tokenLoginChange = (token) =>{
//     let url = '/insurance-web/meinstech/tokenExchange';
//     return _post(url, { 'token' : token });
// };

// 从美云宝跳转过来置换 passId
var tokenLoginChange = function tokenLoginChange(passId) {
    var url = '/insurance-web/meinstech/passIdExchange';
    return Object(__WEBPACK_IMPORTED_MODULE_3__utils_http__["c" /* _post */])(url, { 'passId': passId });
};

// 判断美云宝分销人是不是师傅
var isMaster = function isMaster(mobile) {
    var url = '/insurance-web/meinstech/meiUserQuery';
    return Object(__WEBPACK_IMPORTED_MODULE_3__utils_http__["c" /* _post */])(url, { 'mobile': mobile });
};

/**
 * 通过appToken获取登录信息
 * @param token
 * @returns {Promise}
 */
var getSessionByToken = function getSessionByToken(accessToken) {
    var url = '/insurance-web/session/exchange';
    return Object(__WEBPACK_IMPORTED_MODULE_3__utils_http__["c" /* _post */])(url, { 'token': accessToken });
};

/**
 * 短链接获取地址
 * @param token
 * @returns {Promise}
 */
var getFullPath = function getFullPath(code) {
    var url = '/insurance-web/short/getUrl?code=' + code;
    return Object(__WEBPACK_IMPORTED_MODULE_3__utils_http__["a" /* _get */])(url);
};

/**
 *  保险融合关联手机号
 */
var sendPlusSms = function sendPlusSms(mobile) {
    var url = '/insurance-web/user/plus/sendAuthCodeByPass';
    return Object(__WEBPACK_IMPORTED_MODULE_3__utils_http__["c" /* _post */])(url, { 'mobile': mobile });
};

/**
 *  保险融合关联手机号
 */
var plusBindMobile = function plusBindMobile(code) {
    var url = '/insurance-web/user/plus/bindMobile';
    return Object(__WEBPACK_IMPORTED_MODULE_3__utils_http__["c" /* _post */])(url, { 'code': code });
};

/***/ }),

/***/ "MQTS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dateformat;
/**
 * Created by admin on 2017/4/18.
 */

function dateformat() {};

/**
 * 格式化时间
 * @param date
 * @param fmt
 * @returns {*}
 */
dateformat.format = function (date, fmt) {
    var o = {
        'M+': date.getMonth() + 1, //月份
        'd+': date.getDate(), //日
        'h+': date.getHours(), //小时
        'm+': date.getMinutes(), //分
        's+': date.getSeconds(), //秒
        'q+': Math.floor((date.getMonth() + 3) / 3), //季度
        'S': date.getMilliseconds() //毫秒
    };
    if (!this.isNotEmpty(fmt)) {
        fmt = 'yyyy-MM-dd hh:mm:ss';
    }
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        }
    }
    return fmt;
};

dateformat.formatToDate = function (dateStr) {
    if (this.isNotEmpty(dateStr)) {
        return new Date(Date.parse(dateStr.replace(/-/g, '/')));
    }
    return '';
};

dateformat.getDateStart = function (date) {
    var fmt = 'yyyy/MM/dd';
    var dateStartStr = this.getDateStartStr(date, fmt);
    var startTime = new Date(Date.parse(dateStartStr));
    return startTime;
};

dateformat.getDateStartStr = function (date, fmt) {
    if (typeof fmt == 'undefined') {
        fmt = 'yyyy/MM/dd';
    }
    var dateStr = this.format(date, fmt);
    dateStr += ' 00:00:00';
    return dateStr;
};

dateformat.getDateEnd = function (date) {
    var fmt = 'yyyy/MM/dd';
    var dateEndStr = this.getDateEndStr(date, fmt);
    var endTime = new Date(Date.parse(dateEndStr));
    return endTime;
};

dateformat.getDateEndStr = function (date, fmt) {
    if (typeof fmt == 'undefined') {
        fmt = 'yyyy/MM/dd';
    }
    var endStr = this.format(date, fmt);
    endStr += ' 24:00:00';
    return endStr;
};

dateformat.compareDate = function (d1, d2) {
    if (d1 && d2) {
        if (d1.getTime() > d2.getTime()) {
            return 1;
        } else if (d1.getTime() == d2.getTime()) {
            return 0;
        } else if (d1.getTime() < d2.getTime()) {
            return -1;
        }
    }
};

dateformat.isLeapYear = function (date) {
    if (date instanceof Date) {
        return 0 == date.getYear() % 4 && (date.getYear() % 100 != 0 || date.getYear() % 400 == 0);
    }
    // console.warn('argument format is wrong');
    return false;
};

dateformat.isValidDate = function (dateStr) {
    if (this.isNotEmpty(dateStr)) {
        var r = dateStr.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/);
        if (r == null) {
            return false;
        }
        var d = new Date(r[1], r[3] - 1, r[4]);
        var num = d.getFullYear() == r[1] && d.getMonth() + 1 == r[3] && d.getDate() == r[4];
        return num != 0;
    }
};

dateformat.addDay = function (date, dayNum) {
    if (this.isNotEmpty(date) && this.isNotEmpty(dayNum) && date instanceof Date && typeof dayNum == 'number') {
        date.setDate(date.getDate() + dayNum);
    } else {
        console.warn('date or dayNum format wrong');
    }
    return date;
};

dateformat.addDayStr = function (dateStr, dayNum) {
    var date = '';
    if (this.isNotEmpty(dateStr) && this.isNotEmpty(dayNum) && typeof dayNum == 'number') {
        date = this.formatToDate(dateStr);
        date.setDate(date.getDate() + dayNum);
    } else {
        console.warn('dateStr or dayNum format wrong');
    }
    return date;
};

dateformat.addMonth = function (date, monthNum) {
    if (this.isNotEmpty(date) && this.isNotEmpty(monthNum) && date instanceof Date && typeof monthNum == 'number') {
        date.setMonth(date.getMonth() + monthNum);
    } else {
        console.warn('date or monthNum format wrong');
    }
    return date;
};

dateformat.addMonthStr = function (dateStr, monthNum) {
    var date = '';
    if (this.isNotEmpty(dateStr) && this.isNotEmpty(monthNum) && typeof monthNum == 'number') {
        date = this.formatToDate(dateStr);
        date.setMonth(date.getMonth() + monthNum);
    } else {
        console.warn('date or monthNum format wrong');
    }
    return date;
};

dateformat.addYear = function (date, yearNum) {
    if (this.isNotEmpty(date) && this.isNotEmpty(yearNum) && date instanceof Date && typeof yearNum == 'number') {
        date.setYear(date.getFullYear() + yearNum);
    } else {
        console.warn('date or yearNum format wrong');
    }
    return date;
};

dateformat.addYearStr = function (dateStr, yearNum) {
    var date = '';
    if (this.isNotEmpty(dateStr) && this.isNotEmpty(yearNum) && typeof yearNum == 'number') {
        date = this.formatToDate(dateStr);
        date.setYear(date.getFullYear() + yearNum);
    } else {
        console.warn('date or yearNum format wrong');
    }
    return date;
};

dateformat.isNotEmpty = function (str) {
    if (str != '' && str != null && typeof str != 'undefined') {
        return true;
    }
    console.warn('argument format is wrong');
    return false;
};

dateformat.getWeek = function (date, type) {
    if (date) {
        if (!this.isNotEmpty(type)) {
            type = 0;
        }
        var index = date.getDay();
        var dateStr = '';
        switch (type) {
            case this.WEEKTYPE.ZH_DAYNAME:
                dateStr = this._options.ZH.dayNames[index];
                break;
            case this.WEEKTYPE.ZH_SDAYNAME:
                dateStr = this._options.ZH.shortDayNames[index];
                break;
            case this.WEEKTYPE.US_DAYNAME:
                dateStr = this._options.US.dayNames[index];
                break;
            case this.WEEKTYPE.US_SDAYNAME:
                dateStr = this._options.US.shortDayNames[index];
                break;
        }
        return dateStr;
    }
};

dateformat.getDateDiffNum = function (d1, d2) {
    if (d1 && d2) {
        var dateNum = parseInt((d2.getTime() - d1.getTime()) / (24 * 60 * 60 * 1000));
        return dateNum;
    }
    return '';
};

dateformat.WEEKTYPE = {
    ZH_DAYNAME: 0,
    ZH_SDAYNAME: 1,
    US_DAYNAME: 2,
    US_SDAYNAME: 3
};

dateformat._options = {
    ZH: {
        dayNames: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
        shortDayNames: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
        monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
        shortMonthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
    },
    US: {
        dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        shortDayNames: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        shortMonthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    }
};

dateformat.timeForm = function (time) {
    var year = time.getFullYear();
    var month = time.getMonth() + 1;
    if (month < 10) {
        month = '0' + month;
    }
    var day = time.getDate();
    if (day < 10) {
        day = '0' + day;
    }
    return year + '-' + month + '-' + day;
};

dateformat.checkMinYear = function (cardId, todayDate, ageDetail) {
    //大于多少岁
    var birthday = cardId.substring(6, 14);
    birthday = birthday.substring(0, 4) + '-' + birthday.substring(4, 6) + '-' + birthday.substring(6, 8);
    var nowYear = todayDate.split('-')[0];
    var nowMonth = todayDate.split('-')[1];
    var nowDay = todayDate.split('-')[2];
    var arr = birthday.split('-');
    var value = nowYear - arr[0];
    if (parseInt(arr[1]) > parseInt(nowMonth)) {
        value -= 1;
    } else if (arr[1] == nowMonth) {
        if (parseInt(arr[2]) > parseInt(nowDay)) {
            value -= 1;
        }
    }
    if (value < ageDetail) {
        arr[0] = parseInt(arr[0]) + ageDetail;
        return new Date(arr[0] + '/' + arr[1] + '/' + arr[2] + ' 00:00:00');
    } else {
        return true;
    }
};

dateformat.checkMaxYear = function (cardId, todayDate, ageDetail) {
    //小于多少岁 ok
    // console.log(ageDetail);
    var birthday = cardId.substring(6, 14);
    birthday = birthday.substring(0, 4) + '-' + birthday.substring(4, 6) + '-' + birthday.substring(6, 8);
    var nowYear = todayDate.split('-')[0];
    var nowMonth = todayDate.split('-')[1];
    var nowDay = todayDate.split('-')[2];
    var arr = birthday.split('-');
    var value = nowYear - arr[0];
    if (parseInt(arr[1]) > parseInt(nowMonth)) {
        value -= 1;
    } else if (arr[1] == nowMonth) {
        if (parseInt(arr[2]) > parseInt(nowDay)) {
            value -= 1;
        }
    }
    // console.log(value);
    if (value <= ageDetail) {
        return true;
    } else {
        return false;
    }
};
dateformat.checkMaxYearPA = function (cardId, todayDate, ageDetail) {
    //小于多少岁 ok
    // console.log(ageDetail);
    var birthday = cardId.substring(6, 14);
    birthday = birthday.substring(0, 4) + '-' + birthday.substring(4, 6) + '-' + birthday.substring(6, 8);
    var nowYear = todayDate.split('-')[0];
    var nowMonth = todayDate.split('-')[1];
    var nowDay = todayDate.split('-')[2];
    var arr = birthday.split('-');
    var value = nowYear - arr[0];
    if (parseInt(arr[1]) > parseInt(nowMonth)) {
        value -= 1;
    } else if (arr[1] == nowMonth) {
        if (parseInt(arr[2]) > parseInt(nowDay) + 1) {
            value -= 1;
        }
    }
    // console.log(value);
    if (value <= ageDetail) {
        return true;
    } else {
        return false;
    }
};

dateformat.checkDateBirth = function (cardId) {
    //根据身份证号算出出生日期.

    var birthday = cardId.substring(6, 14);
    birthday = birthday.substring(0, 4) + '-' + birthday.substring(4, 6) + '-' + birthday.substring(6, 8);
    if (birthday !== '--') {
        return birthday;
    }
};

dateformat.checkAge = function (cardId, todayDate) {
    //根据身份证号算出年龄
    if (cardId.length < 18 || cardId.length > 18) {
        return 0;
    }
    var birthday = cardId.substring(6, 14);
    birthday = birthday.substring(0, 4) + '-' + birthday.substring(4, 6) + '-' + birthday.substring(6, 8);
    var nowYear = todayDate.split('-')[0];
    var nowMonth = todayDate.split('-')[1];
    var nowDay = todayDate.split('-')[2];
    var arr = birthday.split('-');
    var value = nowYear - arr[0];

    if (parseInt(arr[1]) > parseInt(nowMonth)) {
        value -= 1;
    } else if (arr[1] == nowMonth) {
        if (parseInt(arr[2]) > parseInt(nowDay)) {
            value -= 1;
        }
    }
    return value;
};
dateformat.checkBirthdayAge = function (cardData, todayDate) {
    //根据出生日期算出年龄
    // let birthday = cardData.substring(6, 14);
    // birthday = birthday.substring(0, 4) + '-' + birthday.substring(4, 6) + '-' + birthday.substring(6, 8);
    var nowYear = todayDate.split('-')[0];
    var nowMonth = todayDate.split('-')[1];
    var nowDay = todayDate.split('-')[2];
    var arr = cardData.split('-');
    var value = nowYear - arr[0];

    if (parseInt(arr[1]) > parseInt(nowMonth)) {
        value -= 1;
    } else if (arr[1] == nowMonth) {
        if (parseInt(arr[2]) > parseInt(nowDay)) {
            value -= 1;
        }
    }
    return value;
};

dateformat.checkGender = function (cardId) {
    //根据身份证号算出性别
    if (parseInt(cardId.substr(16, 1)) % 2 == 1) {
        return 0; //男
    } else {
        return 1; //女
    }
};

dateformat.checkMinMonth = function (cardId, todayDate, monthDetail) {
    //大于多少个月
    var birthday = cardId.substring(6, 14);
    birthday = birthday.substring(0, 4) + '-' + birthday.substring(4, 6) + '-' + birthday.substring(6, 8);
    var nowYear = todayDate.split('-')[0];
    var nowMonth = todayDate.split('-')[1];
    var nowDay = todayDate.split('-')[2];
    var arr = birthday.split('-');
    var value = (nowYear - arr[0]) * 12 + (nowMonth - arr[1]);
    if (parseInt(nowDay) <= parseInt(arr[2])) {
        value = value - 1;
    }
    if (value >= monthDetail) {
        return true;
    } else {
        return dateformat.addMonth(new Date(arr[0] + '/' + arr[1] + '/' + (parseInt(arr[2]) + 1) + ' 00:00:00'), monthDetail);
    }
};
dateformat.checkMaxMonth = function (cardId, todayDate, monthDetail) {
    //小于多少个月
    var birthday = cardId.substring(6, 14);
    birthday = birthday.substring(0, 4) + '-' + birthday.substring(4, 6) + '-' + birthday.substring(6, 8);

    var nowYear = todayDate.split('-')[0];
    var nowMonth = todayDate.split('-')[1];
    var nowDay = todayDate.split('-')[2];
    var arr = birthday.split('-');
    var value = (nowYear - arr[0]) * 12 + (nowMonth - arr[1]);
    if (parseInt(nowDay) <= parseInt(arr[2])) {
        value = value - 1;
    }
    if (value <= monthDetail) {
        return true;
    } else {
        return false;
    }
};

dateformat.checkMinDay = function (cardId, todayDate, dayDetail) {
    //大于多少天 ok
    // console.log(2222,cardId, todayDate,dayDetail);
    var birthday = cardId.substring(6, 14);
    birthday = birthday.substring(0, 4) + '/' + birthday.substring(4, 6) + '/' + birthday.substring(6, 8);
    var time1 = new Date(birthday + ' 00:00:00').getTime();
    todayDate = todayDate.split('-')[0] + '/' + todayDate.split('-')[1] + '/' + todayDate.split('-')[2];
    var time2 = new Date(todayDate + ' 00:00:00').getTime();
    var value = Math.ceil((time2 - time1) / (3600 * 24 * 1000));
    if (value >= dayDetail) {
        return true;
    } else {
        return false;
    }
};

dateformat.checkMaxDay = function (cardId, todayDate, dayDetail) {
    //小于多少天 ok
    var birthday = cardId.substring(6, 14);
    birthday = birthday.substring(0, 4) + '/' + birthday.substring(4, 6) + '/' + birthday.substring(6, 8);
    var time1 = new Date(birthday + ' 00:00:00').getTime();
    todayDate = todayDate.split('-')[0] + '/' + todayDate.split('-')[1] + '/' + todayDate.split('-')[2];
    var time2 = new Date(todayDate + ' 00:00:00').getTime();
    var value = Math.ceil((time2 - time1) / (3600 * 24 * 1000));
    if (value <= dayDetail) {
        return true;
    } else {
        return false;
    }
};

//校验生效日期总封装
//min{ type: '', value: '' } 大于多少天、月、年
//max{ type: '', value: '' } 小于多少天、月、年
//type：year month day
// return code: 1 min不合法   2  max 不合法 0 校验通过
//cardId string  todayDate string min obj max obj
dateformat.checkAll = function (cardId, todayDate, min, max) {
    //首先判断min
    var code = 0;
    if (min) {
        if (min.type == 'year') {
            var res = dateformat.checkMinYear(cardId, todayDate, min.value);
            if (typeof res != 'boolean') {
                code = 1;
                return code;
            }
        } else if (min.type == 'month') {
            var _res = dateformat.checkMinMonth(cardId, todayDate, min.value);
            if (typeof _res != 'boolean') {
                code = 1;
                return code;
            }
        } else if (min.type == 'day') {
            // console.log(11111);
            var _res2 = dateformat.checkMinDay(cardId, todayDate, min.value);
            if (!_res2) {
                code = 1;
                return code;
            }
        }
    }
    if (max) {
        if (max.type == 'year') {
            var _res3 = dateformat.checkMaxYear(cardId, todayDate, max.value);
            if (!_res3) {
                code = 2;
                return code;
            }
        } else if (max.type == 'month') {
            var _res4 = dateformat.checkMaxMonth(cardId, todayDate, max.value);
            if (!_res4) {
                code = 2;
                return code;
            }
        } else if (max.type == 'day') {
            var _res5 = dateformat.checkMaxDay(cardId, todayDate, max.value);
            if (!_res5) {
                code = 2;
                return code;
            }
        }
    }
    return code;
};
// 针对平安E生产品的年龄规则进行判断
dateformat.checkAllPA = function (cardId, todayDate, min, max) {
    //首先判断min
    var code = 0;
    if (min) {
        if (min.type == 'year') {
            var res = dateformat.checkMinYear(cardId, todayDate, min.value);
            if (typeof res != 'boolean') {
                code = 1;
                return code;
            }
        } else if (min.type == 'month') {
            var _res6 = dateformat.checkMinMonth(cardId, todayDate, min.value);
            if (typeof _res6 != 'boolean') {
                code = 1;
                return code;
            }
        } else if (min.type == 'day') {
            var _res7 = dateformat.checkMinDay(cardId, todayDate, min.value);
            if (!_res7) {
                code = 1;
                return code;
            }
        }
    }
    if (max) {
        if (max.type == 'year') {
            var _res8 = dateformat.checkMaxYearPA(cardId, todayDate, max.value);
            if (!_res8) {
                code = 2;
                return code;
            }
        } else if (max.type == 'month') {
            var _res9 = dateformat.checkMaxMonth(cardId, todayDate, max.value);
            if (!_res9) {
                code = 2;
                return code;
            }
        } else if (max.type == 'day') {
            var _res10 = dateformat.checkMaxDay(cardId, todayDate, max.value);
            if (!_res10) {
                code = 2;
                return code;
            }
        }
    }
    return code;
};
/**
 * 计算年龄
 * @param 年龄1 num
 * @param 年龄2 num
 * @param 身份证号码 staring
 * @param 天数 num
 * @returns message
 */
dateformat.yearToYearCheck = function (year1, year2, certificateNo, day) {
    var checkParamsError = '';
    if (year1 && year2) {
        if (/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(certificateNo)) {
            //身份证号
            var birthday = certificateNo.substring(6, 14); // 获取身份证号码上的生日
            birthday = birthday.substr(0, 4) + '-' + birthday.substr(4, 2) + '-' + birthday.substr(6, 2); // 拼成 年-月-日
            var birthdayStr = birthday.replace(/-/g, '/') + ' 00:00:00'; // 拼接时分秒
            var dd = new Date(birthdayStr); // 转换时间格式
            var startTime = dateformat.getDateStart(dateformat.addDay(new Date(), day)); // 计算当前开始day天之后的日期
            dd.setFullYear(dd.getFullYear() + year1); // 设置成有效时身份证对应年龄的年
            // dd为有效年龄日期  startTime起始生效日期
            if (dd.getTime() > startTime.getTime()) {
                // console.log(555555);
                checkParamsError = '请保证身份证年龄在' + year1 + '周岁-' + year2 + '周岁';
            }
            dd.setFullYear(dd.getFullYear() + (year2 - year1)); //再加年龄差 得出最大有效年龄
            if (dd.getTime() < startTime.getTime()) {
                // console.log(666666);
                checkParamsError = '请保证身份证年龄在' + year1 + '周岁-' + year2 + '周岁';
            }
        }
    }
    return checkParamsError;
};

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vuex__ = __webpack_require__("l+I4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lib_flexible_flexible_js__ = __webpack_require__("sVYa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lib_flexible_flexible_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lib_flexible_flexible_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_infinite_scroll__ = __webpack_require__("bqTm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_scroller__ = __webpack_require__("POcy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_scroller___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_scroller__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Interval_js__ = __webpack_require__("sSTJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_exif_js__ = __webpack_require__("sbrb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_exif_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_exif_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_mobile_calendar__ = __webpack_require__("UWoy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_mobile_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_mobile_calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_swiper_dist_css_swiper_css__ = __webpack_require__("v2ns");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pdfh5_css_pdfh5_css__ = __webpack_require__("494y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pdfh5_css_pdfh5_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_pdfh5_css_pdfh5_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_awesome_mui__ = __webpack_require__("V/Xd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_awesome_mui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_awesome_mui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_clipboard2__ = __webpack_require__("wvfG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_clipboard2__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



















// 开发时清除所有sessionStorage缓存
// sessionStorage.clear();

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_14_vue_awesome_mui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_vue_mobile_calendar___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_scroller___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_infinite_scroll___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_15_vue_clipboard2___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.globalInterval = __WEBPACK_IMPORTED_MODULE_8__utils_Interval_js__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.EXIF = __WEBPACK_IMPORTED_MODULE_9_exif_js___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$axios = __WEBPACK_IMPORTED_MODULE_10_axios___default.a;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_2__vuex__["a" /* default */],
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "Pg0u":
/***/ (function(module, exports) {

module.exports = echarts;

/***/ }),

/***/ "QDfD":
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ "Qtao":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = jsbridge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_login_js__ = __webpack_require__("M9A7");



function jsbridge() {}

/**
 * 检测当前浏览器是Android(Chrome) 还是iOS
 */

var ua = navigator.userAgent;
jsbridge.isIPhone = function () {
    if (ua.indexOf('iPhone') > -1) {
        return true;
    }
    return false;
};

jsbridge.isAndroid = function () {
    if (ua.indexOf('Android') > -1) {
        return true;
    }
    return false;
};

/**
 * 链接webView试图浏览器
*/

jsbridge.connectWebViewJavascriptBridge = function (callback) {
    if (window.WebViewJavascriptBridge) {
        return callback(window.WebViewJavascriptBridge);
    }
    if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback);
    }
    window.WVJBCallbacks = [callback];
    var WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'gomescheme://__BRIDGE_LOADED__';
    // WVJBIframe.src = 'gomefinancescheme://__BRIDGE_LOADED__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function () {
        document.documentElement.removeChild(WVJBIframe);
    }, 0);
    // callback();
};

/**
 *  跳转登录页面
 */

jsbridge.reLogin = function () {
    jsbridge.connectWebViewJavascriptBridge(function (bridge) {
        // js 调用 native    方法名       参数     返回数据
        bridge.callHandler('gome_login', '', function (response) {
            // 调用重新登录
            window.location.replace(response);
            if (response === 'cancel') {
                jsbridge.close();
            }
            return response;
        });
    });
};

jsbridge.reLoginAvli = function () {
    jsbridge.connectWebViewJavascriptBridge(function (bridge) {
        // js 调用 native
        bridge.callHandler('gome_login', 'invalidAccessToken', function (response) {
            // 调用重新登录
            return response;
        });
    });
};

/**
 *  关闭当前webView
 */
jsbridge.close = function () {
    jsbridge.connectWebViewJavascriptBridge(function (bridge) {
        // js 调用 native
        bridge.callHandler('gome_close', '', function (response) {
            // 关闭当前webView
        });
    });
};

/**
 *  启动新的webView页面
 */
jsbridge.go2SecondPage = function (data) {
    jsbridge.connectWebViewJavascriptBridge(function (bridge) {
        // js 调用 native
        bridge.callHandler('gome_secondpage', data, function (response) {
            // 启动新的webView页面
        });
    });
};

/**
 *  启动外部浏览器
 */
jsbridge.dowloadPdf = function (data) {
    jsbridge.connectWebViewJavascriptBridge(function (brige) {
        brige.callHandler('gome_download', data, function (response) {});
    });
};

/**
 *  返回上一页
 */
jsbridge.goBack = function () {
    jsbridge.connectWebViewJavascriptBridge(function (brige) {
        brige.callHandler('gome_back', '', function (response) {});
    });
};

/**
 *  控制网页左侧返回键显示隐藏
 */
jsbridge.left = function (data) {
    jsbridge.connectWebViewJavascriptBridge(function (bridge) {
        // js 调用 native
        bridge.callHandler('gome_left', data, function (response) {
            // 控制左侧按钮操作
        });
    });
};

/**
 *  控制右侧按钮操作
 */
jsbridge.right = function (data) {
    jsbridge.connectWebViewJavascriptBridge(function (bridge) {
        // js 调用 native
        bridge.callHandler('gome_right', data, function (response) {
            // 控制右侧按钮操作
        });
    });
};

/**
 *  调取分享、控制title上右侧按钮显示分享按钮，点击分享
 */
jsbridge.goShare = function (data) {
    jsbridge.connectWebViewJavascriptBridge(function (bridge) {
        // js 调用 native
        bridge.callHandler('gome_share', data, function (response) {
            //分享
            response();
        });
    });
};

/**
 *  调取微信支付
 */
jsbridge.wxPay = function (data) {
    jsbridge.connectWebViewJavascriptBridge(function (brige) {
        brige.callHandler('gome_insured_wxpay', data, function (response) {
            //alert('支付结果：' + response);
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
                resolve(response);
            });
        });
    });
};

/**
 *  调取支付宝支付
 */
jsbridge.aliPay = function (data) {
    jsbridge.connectWebViewJavascriptBridge(function (brige) {
        brige.callHandler('gome_insured_alipay', data, function (response) {});
    });
};
/**
*  跳转国美金融App首页
*/
jsbridge.goIndex = function (data) {
    jsbridge.connectWebViewJavascriptBridge(function (brige) {
        brige.callHandler('gome_go_index', data, function (response) {});
    });
};

// 国美金融敏感信息加密需求新增获取aesUuid , aes秘钥
jsbridge.getAesSecretKey = function () {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        setTimeout(function () {
            jsbridge.connectWebViewJavascriptBridge(function (bridge) {
                bridge.callHandler('gome_getAesSecretKey', { flag: true }, function (response) {
                    // alert('返回结果：' + response)
                    resolve(response);
                });
            });
        }, 500);
    });
};

/**
 * login登录
 * @param data
 * @param callback
 */
jsbridge.checkLogin = function (accessToken, callback) {
    alert('进入checkLogin，accessToken:' + accessToken);
    if (accessToken && typeof accessToken != 'undefined') {
        Object(__WEBPACK_IMPORTED_MODULE_1__api_login_js__["f" /* getSessionByToken */])(accessToken).then(function (result) {
            if (result && result.success) {
                localStorage['inviterOwn'] = result.data.userInfo.id;
                callback();
            } else {
                jsbridge.appLogin(callback);
            }
        });
    } else {
        jsbridge.appLogin(callback);
    }
};
//置换登陆态，若无token则不操作
jsbridge.checkLoginRelogin = function (accessToken, callback) {
    //alert('进入checkLogin，accessToken:' + accessToken);
    if (accessToken && typeof accessToken != 'undefined') {
        Object(__WEBPACK_IMPORTED_MODULE_1__api_login_js__["f" /* getSessionByToken */])(accessToken).then(function (result) {
            if (result && result.success) {
                localStorage['inviterOwn'] = result.data.userInfo.id;
                callback();
            } else {
                jsbridge.reLogin();
            }
        });
    } else {
        jsbridge.reLogin();
    }
};

jsbridge.setHeader = function (_ref) {
    var _ref$title = _ref.title,
        title = _ref$title === undefined ? '保险产品' : _ref$title,
        _ref$titleColor = _ref.titleColor,
        titleColor = _ref$titleColor === undefined ? '#000000' : _ref$titleColor,
        _ref$backgroundColor = _ref.backgroundColor,
        backgroundColor = _ref$backgroundColor === undefined ? '#ffffff' : _ref$backgroundColor,
        _ref$backNav = _ref.backNav,
        backNav = _ref$backNav === undefined ? 'black' : _ref$backNav,
        _ref$borderHidden = _ref.borderHidden,
        borderHidden = _ref$borderHidden === undefined ? true : _ref$borderHidden,
        _ref$closeNav = _ref.closeNav,
        closeNav = _ref$closeNav === undefined ? null : _ref$closeNav;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        jsbridge.connectWebViewJavascriptBridge(function (bridge) {
            bridge.callHandler('gome_title', { title: title, titleColor: titleColor, backgroundColor: backgroundColor, backNav: backNav, borderHidden: borderHidden, closeNav: closeNav }, function (response) {
                resolve(response);
            });
        });
    });
};

jsbridge.appLogin = function (callback) {
    jsbridge.connectWebViewJavascriptBridge(function (bridge) {
        bridge.callHandler('gome_login', '', function (response) {
            if (response && response != '') {
                if (response.indexOf('accessToken=') != -1) {
                    var index = response.indexOf('accessToken=');
                    var accessToken = response.substring(index + 'accessToken'.length + 1, response.length);
                    sessionStorage['accessToken'] = accessToken;
                    if (accessToken && accessToken != '') {
                        Object(__WEBPACK_IMPORTED_MODULE_1__api_login_js__["f" /* getSessionByToken */])(accessToken).then(function (result) {
                            if (result && result.success) {
                                //登录成功
                                localStorage['inviterOwn'] = result.data.userInfo.id;
                                callback();
                            }
                        });
                    }
                }
            }
        });
    });
};

/***/ }),

/***/ "UTg/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_TDAPP__ = __webpack_require__("YVHW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_storage__ = __webpack_require__("VKKs");




var addEvent = TDAPP.onEvent;

var mutations = {
    /** 下面是产品的一些状态 **/
    // 设置产品code
    setProductCode: function setProductCode(store, productCode) {
        store.productInfo.productCode = productCode;
        __WEBPACK_IMPORTED_MODULE_3__utils_storage__["a" /* default */].set('productInfo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(store.productInfo));
    },

    // 设置产品pdf
    setAllPdfFile: function setAllPdfFile(store, allPdfFile) {
        //
        store.productInfo.allPdfFile = allPdfFile;
        __WEBPACK_IMPORTED_MODULE_3__utils_storage__["a" /* default */].set('productInfo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(store.productInfo));
    },

    // 设置产品保障范围
    setInsuranceScope: function setInsuranceScope(store, insuranceScope) {
        //
        store.productInfo.insuranceScope = insuranceScope;
        __WEBPACK_IMPORTED_MODULE_3__utils_storage__["a" /* default */].set('productInfo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(store.productInfo));
    },

    // 设置保障期限
    setTimeLimit: function setTimeLimit(store, timeLimit) {
        store.insureInfo.timeLimit = timeLimit;
        __WEBPACK_IMPORTED_MODULE_3__utils_storage__["a" /* default */].set('insureInfo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(store.insureInfo));
    },

    // 设置银行信息
    setBankInfo: function setBankInfo(store, bankInfo) {
        store.insureInfo.bankInfo = bankInfo;
        __WEBPACK_IMPORTED_MODULE_3__utils_storage__["a" /* default */].set('insureInfo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(store.insureInfo));
    },

    /** 下面是投保录入的一些状态 **/
    // 保存被保人信息
    setInsuredInfo: function setInsuredInfo(store, insuredInfo) {
        store.insureInfo.insuredInfo = insuredInfo;
        __WEBPACK_IMPORTED_MODULE_3__utils_storage__["a" /* default */].set('insureInfo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(store.insureInfo));
    },

    // 保存投保人信息
    setHolderInfo: function setHolderInfo(store, holderInfo) {
        store.insureInfo.holderInfo = holderInfo;
        __WEBPACK_IMPORTED_MODULE_3__utils_storage__["a" /* default */].set('insureInfo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(store.insureInfo));
    },

    // 设置confirmSubmitId
    setConfirmSubmitId: function setConfirmSubmitId(store, confirmSubmitId) {
        store.insureInfo.confirmSubmitId = confirmSubmitId;
        __WEBPACK_IMPORTED_MODULE_3__utils_storage__["a" /* default */].set('insureInfo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(store.insureInfo));
    },

    // 设置confirmSubmitId
    setTotalPrice: function setTotalPrice(store, totalPrice) {
        store.insureInfo.totalPrice = totalPrice;
        __WEBPACK_IMPORTED_MODULE_3__utils_storage__["a" /* default */].set('insureInfo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(store.insureInfo));
    },

    // 设置保单价格
    setInsurePrice: function setInsurePrice(store, price) {
        store.insureInfo.price = price;
        __WEBPACK_IMPORTED_MODULE_3__utils_storage__["a" /* default */].set('insureInfo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(store.insureInfo));
    },

    // 试算项
    setCountPrice: function setCountPrice(store, information) {
        store.information = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, store.information, information);
        __WEBPACK_IMPORTED_MODULE_3__utils_storage__["a" /* default */].set('information', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(store.information));
    },
    setChargeYear: function setChargeYear(store, chargeYear) {
        store.information = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, store.information, { chargeYear: chargeYear });
        __WEBPACK_IMPORTED_MODULE_3__utils_storage__["a" /* default */].set('information', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(store.information));
    },
    setAmount: function setAmount(store, amount) {
        store.information = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, store.information, { amount: amount + '0000' });
        __WEBPACK_IMPORTED_MODULE_3__utils_storage__["a" /* default */].set('information', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(store.information));
    },

    /** 下面是投保身份证录入的一些状态 **/
    /**
     * 设置投保人身份证图片
     * @param store
     * @param key {uploadImageBack | uploadImageFront}
     * @param value
     */
    setHolderIdCardInfoByUploadImage: function setHolderIdCardInfoByUploadImage(store, _ref) {
        var key = _ref.key,
            value = _ref.value;

        store.insuredIdCardUploadInfo.holder[key] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ category: key }, value);
        __WEBPACK_IMPORTED_MODULE_3__utils_storage__["a" /* default */].set('insuredIdCardUploadInfo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(store.insuredIdCardUploadInfo));
    },

    /**
     * 设置被保人身份证图片
     * @param store
     * @param key {uploadImageBack | uploadImageFront}
     * @param value 值
     * @param index 第几个
     */
    setInsurersIdCardInfoByUploadImage: function setInsurersIdCardInfoByUploadImage(store, _ref2) {
        var key = _ref2.key,
            value = _ref2.value,
            _ref2$index = _ref2.index,
            index = _ref2$index === undefined ? 0 : _ref2$index;

        store.insuredIdCardUploadInfo.insurers[index][key] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ category: key }, value);
        __WEBPACK_IMPORTED_MODULE_3__utils_storage__["a" /* default */].set('insuredIdCardUploadInfo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(store.insuredIdCardUploadInfo));
    },

    /**
     * 存储下单流程
     */
    setOrderProcessUploadImage: function setOrderProcessUploadImage(store, _ref3) {
        var key = _ref3.key,
            value = _ref3.value;

        // alert('到这了');
        // console.log(key,value);
        store.OrderProcessUploadInfo[key] = { processName: key, imageUrl: value };
        __WEBPACK_IMPORTED_MODULE_3__utils_storage__["a" /* default */].set('OrderProcessUploadInfo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(store.OrderProcessUploadInfo));
    },

    // 登录页
    setLoginPhone: function setLoginPhone(store, phone) {
        store.login.phone = phone;
        __WEBPACK_IMPORTED_MODULE_3__utils_storage__["a" /* default */].set('login', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(store.login));
    }

};

__WEBPACK_IMPORTED_MODULE_2__constants_TDAPP__["Q" /* TD */].forEach(function (v) {
    mutations[v.eventId] = function (state, value) {
        value = value || '';
        var params = v.eventParmas(value.id || -1),
            label = v.eventLabel(value) || params.eventName;
        addEvent(v.eventId, label, params);
    };
});



/***/ }),

/***/ "Ued4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'HelloWorld',
    computed: {
        count: function count() {
            return this.$store.state.app.count;
        }
    },
    data: function data() {
        return {
            msg: 'Welcome to Your Vue.js App'
        };
    },
    created: function created() {
        _post('/insurance-web/productList/productList', {
            'typeId': 1,
            'page': 1,
            'pageSize': 10,
            'showType': 1
        }).then(function (res) {
            // console.log(res);
        });
    }
});

/***/ }),

/***/ "VKKs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



/**
 * 缓存工具类
 */
var StorageUtil = function () {
    function StorageUtil() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, StorageUtil);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(StorageUtil, [{
        key: 'set',
        value: function set(key, value) {
            // 设置 sessionStorage
            window.sessionStorage && sessionStorage.setItem(key, value);
        }
    }, {
        key: 'get',
        value: function get(key) {
            //获取 sessionStorage
            var val = window.sessionStorage && sessionStorage.getItem(key);
            return val ? val : '';
        }
    }, {
        key: 'remove',
        value: function remove(key) {
            // 删除 sessionStorage
            window.sessionStorage && sessionStorage.removeItem(key);
        }
    }, {
        key: 'setNoCover',
        value: function setNoCover(key, value) {
            if (!sessionStorage.getItem(key)) {
                sessionStorage.setItem(key, value);
            }
        }
    }, {
        key: 'setL',
        value: function setL(key, value) {
            // 设置 localStorage
            window.localStorage && localStorage.setItem(key, value);
        }
    }, {
        key: 'getL',
        value: function getL(key) {
            //获取 localStorage
            var val = window.localStorage && localStorage.getItem(key);
            return val ? val : '';
        }
    }, {
        key: 'removeL',
        value: function removeL(key) {
            //删除 localStorage
            window.localStorage && localStorage.removeItem(key);
        }
    }, {
        key: 'setLNoCover',
        value: function setLNoCover(key, value) {
            if (!localStorage.getItem(key)) {
                localStorage.setItem(key, value);
            }
        }
    }]);

    return StorageUtil;
}();

var storage = new StorageUtil(); //初始化缓存类

/* harmony default export */ __webpack_exports__["a"] = (storage);

/***/ }),

/***/ "WMeU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getters; });
var getters = {
    /** 身份证上传页面相关数据 **/
    getHolderIdCardInfo: function getHolderIdCardInfo(store) {
        return store.insuredIdCardUploadInfo.holder;
    },
    getInsurersIdCardInfo: function getInsurersIdCardInfo(store, getters) {
        return store.insuredIdCardUploadInfo.insurers;
    },

    /** 产品状态 **/
    getProductCode: function getProductCode(store, getters) {
        return store.productInfo.productCode;
    },
    getProductAllPdfFile: function getProductAllPdfFile(store, getters) {
        return store.productInfo.allPdfFile;
    },
    getProductInsuranceScope: function getProductInsuranceScope(store, getters) {
        return store.productInfo.insuranceScope;
    },

    /** 投保数据 **/
    getTimeLimit: function getTimeLimit(store, getters) {
        return store.insureInfo.timeLimit;
    },
    getBankInfo: function getBankInfo(store, getters) {
        return store.insureInfo.bankInfo;
    },
    getInsureInsuredInfo: function getInsureInsuredInfo(store, getters) {
        return store.insureInfo.insuredInfo;
    },
    getInsureHolderInfo: function getInsureHolderInfo(store, getters) {
        return store.insureInfo.holderInfo;
    },
    getConfirmSubmitId: function getConfirmSubmitId(store, getters) {
        return store.insureInfo.confirmSubmitId;
    },
    getInsurePrice: function getInsurePrice(store, getters) {
        return store.insureInfo.price;
    },
    getInsureTotalPrice: function getInsureTotalPrice(store, getters) {
        return store.insureInfo.totalPrice;
    },
    getOrderProcessUploadImage: function getOrderProcessUploadImage(store, getters) {
        return store.OrderProcessUploadInfo;
    }
};

/***/ }),

/***/ "WXYk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cookieUtils; });
/**
 * Created by admin on 2017/3/14.
 */

var cookieUtils = function cookieUtils() {};

function getCookieVal(offset) {
    var endstr = document.cookie.indexOf(';', offset);
    if (endstr == -1) {
        endstr = document.cookie.length;
    }
    return unescape(document.cookie.substring(offset, endstr));
};

cookieUtils.delCookie = function (name) {
    var Days = 1;
    var exp = new Date();
    exp.setTime(exp.getTime() - Days * 24 * 60 * 60 * 1000);
    var cookieStr = name + '= ; expires=' + exp.toGMTString() + '';
    //consoe.log.log(cookieStr+'');
    document.cookie = cookieStr;
};

cookieUtils.delRootCookie = function (name) {
    var Days = 1;
    var exp = new Date();
    exp.setTime(exp.getTime() - Days * 24 * 60 * 60 * 1000);
    var cookieStr = name + '=; expires=' + exp.toGMTString() + ';domain=gomelife.com;path=/';
    document.cookie = cookieStr;
};

cookieUtils.getCookie = function (name) {
    var arg = name + '=';
    var alen = arg.length;
    var clen = document.cookie.length;
    var i = 0;
    while (i < clen) {
        var j = i + alen;
        if (document.cookie.substring(i, j) == arg) {
            return getCookieVal(j);
        }
        i = document.cookie.indexOf(' ', i) + 1;
        if (i == 0) {
            break;
        }
    }
    return null;
};

cookieUtils.setCookie = function (name, value) {
    var exp = new Date();
    exp.setTime(exp.getTime() + 60 * 1000 * 30); //过期时间 30分钟
    document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString();
};

/***/ }),

/***/ "YVHW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return HDBX0501001; });
/* unused harmony export HDBX0501002 */
/* unused harmony export BX010001 */
/* unused harmony export BX010002 */
/* unused harmony export BX010003 */
/* unused harmony export BX010004 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BX010005; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BX010006; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BX010007; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BX010008; });
/* unused harmony export BX010009 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BX010010; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BX010011; });
/* unused harmony export BX010012 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return BX010013; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return BX010014; });
/* unused harmony export BX010015 */
/* unused harmony export BX010016 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return BX010017; });
/* unused harmony export BX010018 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return BX010019; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return BX010020; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return BX020001; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return BX020002; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return BX030001; });
/* unused harmony export BX030002 */
/* unused harmony export BX030003 */
/* unused harmony export BX030004 */
/* unused harmony export BX030005 */
/* unused harmony export BX030006 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return BX030007; });
/* unused harmony export BX040001 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return BX040002; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return BX040003; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return BX040004; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return BX040005; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return BX040006; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return BX040007; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return BX040008; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return BX050001; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return BX050002; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return BX050003; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return BX050004; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return BX060001; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return BX060002; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return BX060003; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return BX060004; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return BX060005; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return BX060006; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return BX060007; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return BX060008; });
/* unused harmony export BX060009 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return BX070001; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return BX070002; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return BX080001; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return BX080002; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return BX080003; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return BX080004; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return BX080005; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return TD; });

// H5美途保游戏
var HDBX0501001 = 'HDBX0501001';
var HDBX0501002 = 'HDBX0501002';

// 首页
var BX010001 = 'BX010001';
var BX010002 = 'BX010002';
var BX010003 = 'BX010003';
var BX010004 = 'BX010004';
var BX010005 = 'BX010005';
var BX010006 = 'BX010006';
var BX010007 = 'BX010007';
var BX010008 = 'BX010008';
var BX010009 = 'BX010009';
var BX010010 = 'BX010010';
var BX010011 = 'BX010011';
var BX010012 = 'BX010012';
var BX010013 = 'BX010013';
var BX010014 = 'BX010014';
var BX010015 = 'BX010015';
var BX010016 = 'BX010016';
var BX010017 = 'BX010017';
var BX010018 = 'BX010018';
var BX010019 = 'BX010019';
var BX010020 = 'BX010020';

// 产品列表页
var BX020001 = 'BX020001';
var BX020002 = 'BX020002';

// 发现页
var BX030001 = 'BX030001';
var BX030002 = 'BX030002';
var BX030003 = 'BX030003';
var BX030004 = 'BX030004';
var BX030005 = 'BX030005';
var BX030006 = 'BX030006';
var BX030007 = 'BX030007';

// 个人中心
var BX040001 = 'BX040001';
var BX040002 = 'BX040002';
var BX040003 = 'BX040003';
var BX040004 = 'BX040004';
var BX040005 = 'BX040005';
var BX040006 = 'BX040006';
var BX040007 = 'BX040007';
var BX040008 = 'BX040008';

// 产品详情页
var BX050001 = 'BX050001';
var BX050002 = 'BX050002';
var BX050003 = 'BX050003';
var BX050004 = 'BX050004';

// 在线投保
var BX060001 = 'BX060001';
var BX060002 = 'BX060002';
var BX060003 = 'BX060003';
var BX060004 = 'BX060004';
var BX060005 = 'BX060005';
var BX060006 = 'BX060006';
var BX060007 = 'BX060007';
var BX060008 = 'BX060008';
var BX060009 = 'BX060009';

// App 引流
var BX070001 = 'BX070001';
var BX070002 = 'BX070002';

// 续保页
var BX080001 = 'BX080001';
var BX080002 = 'BX080002';
var BX080003 = 'BX080003';
var BX080004 = 'BX080004';
var BX080005 = 'BX080005';

var TD = [
// H5美途保游戏
{
    eventId: HDBX0501001,
    eventName: '活动首页，点击开始',
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '点击开始',
            adPosition: '输入昵称下方点击开始按钮',
            rootPosition: '活动首页'
        };
    }
}, {
    eventId: HDBX0501002,
    eventName: '测试结果页，领取美途保按钮',
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '点击领取',
            adPosition: '页面底部领取美途保按钮',
            rootPosition: '测试结果页'
        };
    }
},
// 首页
{
    eventId: BX010001,
    eventLabel: function eventLabel(value) {
        return '' + value.title;
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '顶部产品推荐按钮点击',
            adPosition: '顶部产品推荐',
            rootPosition: '顶部产品推荐'
        };
    }
}, {
    eventId: BX010002,
    eventLabel: function eventLabel(value) {
        return 'Banner\u8F6E\u64AD\u56FE-' + value.index + '-' + value.title;
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: 'Banner轮播图',
            adPosition: 'Banner轮播图',
            rootPosition: '顶部banner'
        };;
    }
}, {
    eventId: BX010003,
    eventLabel: function eventLabel(value) {
        return 'Icon\u5206\u7C7B-' + value.categoryId;
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: 'Icon分类图标切换',
            adPosition: 'Icon分类',
            rootPosition: ''
        };;
    }
}, {
    eventId: BX010004,
    eventLabel: function eventLabel(value) {
        return 'Icon\u5206\u7C7B-' + value.categoryId + '-' + value.name;
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: 'Icon分类产品点击',
            adPosition: 'Icon分类'
        };;
    }
}, {
    eventId: BX010005,
    eventLabel: function eventLabel(value) {
        return 'Icon\u5206\u7C7B-' + value.categoryId;
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: 'Icon分类更多',
            adPosition: 'Icon分类'
        };;
    }
}, {
    eventId: BX010006,
    eventLabel: function eventLabel(value) {
        return value.where + '-' + value.categoryId + '-' + value.name;
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: 'Icon分类产品列表产品点击',
            adPosition: 'Icon分类'
        };;
    }
}, {
    eventId: BX010007,
    eventLabel: function eventLabel(value) {
        return '\u8EAB\u4EFD\u7279\u8D28-' + value.id;
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '身份特质点击',
            adPosition: '身份特质',
            rootPosition: '身份特质'
        };;
    }
}, {
    eventId: BX010008,
    eventLabel: function eventLabel(value) {
        return value.where + '-' + value.name;
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '身份特质产品列表产品点击',
            adPosition: '身份特质二级页面',
            rootPosition: '身份特质'
        };;
    }
}, {
    eventId: BX010009,
    eventLabel: function eventLabel(value) {
        return '' + value.name;
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '国美专享产品',
            adPosition: '国美专享',
            rootPosition: '国美专享'
        };;
    }
}, {
    eventId: BX010010,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '国美专享更多',
            adPosition: '国美专享',
            rootPosition: '国美专享'
        };;
    }
}, {
    eventId: BX010011,
    eventLabel: function eventLabel(value) {
        return '\u56FD\u7F8E\u4E13\u4EAB-' + value.name;
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '国美专享产品列表产品点击',
            adPosition: '国美专享二级页面',
            rootPosition: '国美专享'
        };;
    }
}, {
    eventId: BX010012,
    eventLabel: function eventLabel(value) {
        return '' + value.name;
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '特惠精选产品',
            adPosition: '特惠精选',
            rootPosition: '特惠精选'
        };;
    }
}, {
    eventId: BX010013,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '特惠精选更多',
            adPosition: '特惠精选',
            rootPosition: '特惠精选'
        };
    }
}, {
    eventId: BX010014,
    eventLabel: function eventLabel(value) {
        return '\u7279\u60E0\u7CBE\u9009-' + value.name;
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '特惠精选产品列表产品点击',
            adPosition: '特惠精选二级页面',
            rootPosition: '特惠精选'
        };
    }
}, {
    eventId: BX010015,
    eventLabel: function eventLabel(value) {
        return value.title + '-' + value.index;
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '小保说Banner',
            adPosition: '小保说',
            rootPosition: '小保说'
        };
    }
}, {
    eventId: BX010016,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '小保说更多',
            adPosition: '小保说',
            rootPosition: '小保说'
        };
    }
}, {
    eventId: BX010017,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '点击首页',
            adPosition: '首页',
            rootPosition: '底部导航'
        };
    }
}, {
    eventId: BX010018,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '点击产品',
            adPosition: '产品',
            rootPosition: '底部导航'
        };
    }
}, {
    eventId: BX010019,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '点击发现',
            adPosition: '发现',
            rootPosition: '底部导航'
        };
    }
}, {
    eventId: BX010020,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '点击我的',
            adPosition: '我的',
            rootPosition: '底部导航'
        };
    }
}, {
    eventId: BX020001,
    eventLabel: function eventLabel(value) {
        return '' + value.id;
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '产品分类切换',
            adPosition: '产品列表页',
            rootPosition: '产品列表页'
        };
    }
}, {
    eventId: BX020002,
    eventLabel: function eventLabel(value) {
        return value.productCatesId + '-' + value.name;
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '产品点击',
            adPosition: '产品列表页',
            rootPosition: '产品列表页'
        };
    }
}, {
    eventId: BX030001,
    eventLabel: function eventLabel(value) {
        return value.name + '-' + value.index;
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: 'Banner轮播图',
            adPosition: 'Banner轮播图',
            rootPosition: '发现页'
        };
    }
}, {
    eventId: BX030002,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '点击预约咨询',
            adPosition: '预约咨询',
            rootPosition: '发现页'
        };
    }
}, {
    eventId: BX030003,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '点击体检预约',
            adPosition: '体检预约',
            rootPosition: '发现页'
        };
    }
}, {
    eventId: BX030004,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '点击境外救援',
            adPosition: '境外救援',
            rootPosition: '发现页'
        };
    }
}, {
    eventId: BX030005,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '点击齿科服务',
            adPosition: '齿科服务',
            rootPosition: '发现页'
        };
    }
}, {
    eventId: BX030006,
    eventLabel: function eventLabel(value) {
        return value.id + '-' + value.index;
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: 'Icon分类切换',
            adPosition: 'Icon分类',
            rootPosition: '发现页'
        };
    }
}, {
    eventId: BX030007,
    eventLabel: function eventLabel(value) {
        return value.id + '-' + value.articleId;
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '保险小课堂列表文章点击',
            adPosition: '保险小课堂',
            rootPosition: '发现页'
        };
    }
}, {
    eventId: BX040001,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '我的理财',
            adPosition: '我的理财',
            rootPosition: '个人中心'
        };
    }
}, {
    eventId: BX040002,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '保障中',
            adPosition: '我的保障',
            rootPosition: '个人中心'
        };
    }
}, {
    eventId: BX040003,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '已失效',
            adPosition: '我的保障',
            rootPosition: '个人中心'
        };
    }
}, {
    eventId: BX040004,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '待支付',
            adPosition: '我的保障',
            rootPosition: '个人中心'
        };
    }
}, {
    eventId: BX040005,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '全部保障',
            adPosition: '我的保障',
            rootPosition: '个人中心'
        };
    }
}, {
    eventId: BX040006,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '我的权益',
            adPosition: '我的权益',
            rootPosition: '个人中心'
        };
    }
}, {
    eventId: BX040007,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '点击常用联系人',
            adPosition: '常用联系人',
            rootPosition: '个人中心'
        };
    }
}, {
    eventId: BX040008,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '添加常用联系人',
            adPosition: '常用联系人列表',
            rootPosition: '个人中心'
        };
    }
}, {
    eventId: BX050001,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '立即投保',
            adPosition: '产品详情页',
            rootPosition: '产品详情页'
        };
    }
}, {
    eventId: BX050002,
    eventLabel: function eventLabel(value) {
        return value.name + '-' + value.index;
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '保障分类tab切换',
            adPosition: '保障分类',
            rootPosition: '产品详情页'
        };
    }
}, {
    eventId: BX050003,
    eventLabel: function eventLabel(value) {
        return value.name + '-' + value.index;
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '内容分类tab切换',
            adPosition: '内容分类',
            rootPosition: '产品详情页'
        };
    }
}, {
    eventId: BX050004,
    eventLabel: function eventLabel(value) {
        return '' + value.name;
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '条款阅读',
            adPosition: '产品详情页',
            rootPosition: '产品详情页'
        };
    }
}, {
    eventId: BX060001,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '全部为否',
            adPosition: '健康告知',
            rootPosition: '在线投保'
        };
    }
}, {
    eventId: BX060002,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '全部为是',
            adPosition: '健康告知',
            rootPosition: '在线投保'
        };
    }
}, {
    eventId: BX060003,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '常用联系人',
            adPosition: '投保信息填写页',
            rootPosition: '在线投保'
        };
    }
}, {
    eventId: BX060004,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '相关条款',
            adPosition: '投保信息填写页',
            rootPosition: '在线投保'
        };
    }
}, {
    eventId: BX060005,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '立即投保',
            adPosition: '投保信息填写页',
            rootPosition: '在线投保'
        };
    }
}, {
    eventId: BX060006,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '确认支付',
            adPosition: '收银台',
            rootPosition: '在线投保'
        };
    }
}, {
    eventId: BX060007,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '查看保单',
            adPosition: '投保结果页面',
            rootPosition: '在线投保'
        };
    }
}, {
    eventId: BX060008,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '返回首页',
            adPosition: '投保结果页面',
            rootPosition: '在线投保'
        };
    }
}, {
    eventId: BX060009,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '返回产品详情',
            adPosition: '投保结果页面',
            rootPosition: '在线投保'
        };
    }
}, {
    eventId: BX070001,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '点击“立即购买”',
            adPosition: '立即购买按钮',
            rootPosition: 'H5产品详情页'
        };
    }
}, {
    eventId: BX070002,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '前往投保成功页',
            adPosition: '投保成功页',
            rootPosition: 'H5投保成功页'
        };
    }
}, {
    eventId: BX080001,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '点击续保按钮',
            adPosition: '保单详情页',
            rootPosition: '保单详情页'
        };
    }
}, {
    eventId: BX080003,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '续保按钮前往续保页面',
            adPosition: '续保页',
            rootPosition: '续保页'
        };
    }
}, {
    eventId: BX080004,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '微信模版消息前往续保页面',
            adPosition: '续保页',
            rootPosition: '续保页'
        };
    }
}, {
    eventId: BX080005,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '短信前往续保页面',
            adPosition: '续保页',
            rootPosition: '续保页'
        };
    }
}, {
    eventId: BX080002,
    eventLabel: function eventLabel(value) {
        return typeof value === 'string' ? value : '';
    },
    eventParmas: function eventParmas(id) {
        return {
            id: id,
            eventName: '点击立即投保按钮',
            adPosition: '续保页',
            rootPosition: '续保页'
        };
    }
}];

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_index__ = __webpack_require__("2NXm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_wechat__ = __webpack_require__("FJ1s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_login__ = __webpack_require__("M9A7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_storage__ = __webpack_require__("VKKs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_cookieUtils__ = __webpack_require__("WXYk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_util_js__ = __webpack_require__("oFuF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_constants__ = __webpack_require__("8x0Q");


var _this2 = this;












__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
    mode: 'history',
    base: __dirname,
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },

    routes: [
    //短期活动：2019尊享e生（妈妈版）
    {
        path: '/shortTermActivity/holeLifeForMather',
        name: 'holeLifeForMather',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(146).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Hssm")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    },
    //京康源信息填写页面
    {
        path: '/insured/bjrsJKY',
        name: 'insuredBjrsJKY',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Arnz")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/agreement',
        name: 'Agreement',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(104).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("guV2")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/rule',
        name: 'rule',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(103).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Ij2A")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    },
    // 对接pass登录需求
    {
        path: '/login/passUnify',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(151).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("hOY4")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        children: [{ path: '/', name: 'passUnifyLogin', component: function component(resolve) {
                return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("t7yn")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            } }, { path: 'password/:type', name: 'LoginPassword', component: function component(resolve) {
                return __webpack_require__.e/* require */(10).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("mQg/")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            } }, { path: 'SMS/:type', name: 'LoginForSMS', component: function component(resolve) {
                return __webpack_require__.e/* require */(46).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("mTjs")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            } }]
    },
    //对接代理人平台
    {
        path: '/agent',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(154).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("SsaK")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        children: [{ path: 'personalInfo', name: 'PersonalInfo', component: function component(resolve) {
                return __webpack_require__.e/* require */(80).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Y/5T")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            } }, { path: 'personalInfoSure', name: 'PersonalInfoSure', component: function component(resolve) {
                return __webpack_require__.e/* require */(76).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("6Izn")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            } }, { path: 'idCardUpdate', name: 'idCardUpdate', component: function component(resolve) {
                return __webpack_require__.e/* require */(57).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("befk")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            } }, { path: 'larger', name: 'larger', component: function component(resolve) {
                return __webpack_require__.e/* require */(153).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("RVh4")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            } }, { path: 'auditResult', name: 'auditResult', component: function component(resolve) {
                return __webpack_require__.e/* require */(102).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("RhJJ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            } }, { path: 'agentInvite', name: 'agentInvite', component: function component(resolve) {
                return __webpack_require__.e/* require */(106).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("+MxD")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            } }]
    },
    //修改手机号
    {
        path: '/changePhone',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(120).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("RW7v")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        children: [{ path: 'chooseType', name: 'ChooseType', component: function component(resolve) {
                return __webpack_require__.e/* require */(132).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("rcTm")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            } }, { path: 'checkPassword', name: 'CheckPassword', component: function component(resolve) {
                return __webpack_require__.e/* require */(119).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("v/Yr")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            } }, { path: 'inputPhone', name: 'InputPhone', component: function component(resolve) {
                return __webpack_require__.e/* require */(118).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("vFXR")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            } }, { path: 'checkSMS', name: 'CheckSMS', component: function component(resolve) {
                return __webpack_require__.e/* require */(75).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Bcsy")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            } }]
    },
    //合作三方平台公示
    {
        path: '/publicity',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(148).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("li8z")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        children: [{ path: 'publicity', name: 'Publicity', component: function component(resolve) {
                return __webpack_require__.e/* require */(124).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("sR0M")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            } }, { path: 'publicityList', name: 'PublicityList', component: function component(resolve) {
                return __webpack_require__.e/* require */(147).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("wmAe")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            } }]
    },

    // 规则及服务保障
    {
        path: '/ruleService/ruleService',
        name: 'ruleService',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(81).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("pco0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    },

    //阳光赠险(出行)
    {
        path: '/activity/giveYg',
        name: 'activityGiveYg',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(19).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2ytm")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    },
    //阳光赠险(重疾)
    {
        path: '/activity/giveZj',
        name: 'activityGiveZj',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(18).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("0LF5")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    },
    //
    {
        path: '/activity/epidemicList',
        name: 'activityEpidemicList',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(36).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("TVZO")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    },
    //京康源信息填写页面
    {
        path: '/insured/bjrsJKY',
        name: 'insuredBjrsJKY',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(0/* duplicate */).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Arnz")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    },
    //永诚财险填写页面
    {
        path: '/insured/productYccx',
        name: 'productYccx',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ITqK")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    },
    // 法律和隐私政策
    {
        path: '/login/lowAndPrivacyPolicy',
        name: 'lowAndPrivacyPolicy',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(149).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("NOY9")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    },
    // 用户注册国美保险经纪服务协议
    {
        path: '/login/serviceProtocol',
        name: 'serviceProtocol',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(150).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("SCud")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, { // 信息确认页
        path: '/insured/confirm/:confirmSubmitId',
        name: 'insuredconfirmData',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(63).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("QLZ+")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, { // 信息确认页
        path: '/insured/confirmTK/:confirmSubmitId',
        name: 'insuredconfirmData',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(61).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("xnOS")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, { // 信息确认页
        path: '/insured/confirmTwo/:confirmSubmitId',
        name: 'insuredconfirmDataTwo',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(49).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2YiF")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, { // 改版后信息确认页
        path: '/insured/newConfirm/:confirmSubmitId',
        name: 'insuredNewConfirmDataTwo',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("JbQ2")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, { // 身份证上传页面
        path: '/insured/idCardUpload/:type',
        name: 'insuredIdCardUpload',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(60).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Oe7o")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, { // 投连身份证上传页面
        path: '/insured/toulianIdCardUpload/:type',
        name: 'toulianIdCardUpload',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(53).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("OIif")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/groupInsurance/insure',
        name: 'groupInsuranceInsure',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(62).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("p5tU")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/notice',
        name: 'notice',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(156).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("+2is")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/internalWelfare',
        name: 'internalWelfare',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("7B6x")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/internalMell',
        name: 'internalMell',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(22).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("nulk")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/worldCup/insured',
        name: 'worldCupInsured',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(64).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("d9mR")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/worldCup/score',
        name: 'worldCuoScore',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(89).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("diZA")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/worldCup',
        name: 'world-cup',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(45).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("xReY")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/bindPlusMobile',
        name: 'bindPlusMobile',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(77).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Z+XG")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/motherDay/poster',
        name: 'motherPoster',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(83).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("L5u9")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/mtb/serp',
        name: 'mtbSerp',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(86).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("KaVf")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/mtb/answer',
        name: 'mtbAnswer',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(108).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("9awe")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/mtb/home',
        name: 'mtbHome',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(98).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("EEPP")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/megaPrice/poster',
        name: 'megaPricePoster',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(121).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("RLXb")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/megaPrice',
        name: 'megaPrice',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(51).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("CkJr")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/myAward',
        name: 'myAward',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(109).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("3plB")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/rules',
        name: 'rules',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(155).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ql2I")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    },
    // {
    //     path: '/activity/writeAddress',
    //     name: 'writeAddress',
    //     component: resolve => require(['../pages/activity/lottery/address.vue'], resolve)
    // },
    {
        path: '/activity/carLottery',
        name: 'carLottery',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("0J+x")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/stepNumber',
        name: 'stepNumber',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(114).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("a3J9")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/carGround',
        name: 'carGrounder',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(42).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("jDuq")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/carJinChao',
        name: 'carJinChao',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(55).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("QGcA")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/appointment',
        name: 'appointment',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(39).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2jRV")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/appointSuccess',
        name: 'appointSuccess',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(125).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("o5Vy")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/poster',
        name: 'poster',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(117).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("nDqq")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/carShare',
        name: 'carShare',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(54).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("sCmq")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/elevenShare',
        name: 'elevenShare',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(68).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("hEwW")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/giveZa',
        name: 'activityGiveZa',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(30).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("9WLc")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/giveZaPc',
        name: 'activityGiveZaPc',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(37).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("QzOr")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/motherDay',
        name: 'activityMotherDay',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(78).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("GvyY")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/activity/guess',
        name: 'activityGuess',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("vGco")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/toulian/redempPolicyDetail/:policyId',
        name: 'toulianRedempPolicyDetail',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(110).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("+yvs")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/toulian/redemption',
        name: 'toulianRedemption',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(85).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("XLT9")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/toulian/handlerDetail/:policyId',
        name: 'toulianHandlerDetail',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(87).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("HkXT")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/toulian/incomeDetail/:policyId',
        name: 'toulianIncomeDetail',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(58).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("anN/")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/toulian/addDetail/:policyId',
        name: 'toulianAddDetail',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(74).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("64r9")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/toulian/xuzhi',
        name: 'toulianUserXuzhi',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(112).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("94Vw")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/toulian/riskAppraisal',
        name: 'riskAppraisal',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(90).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("3b0T")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/toulian/income',
        name: 'income',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(96).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("aKY1")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/toulian/payResult',
        name: 'payResult',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(92).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("eInR")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/toulian/pay',
        name: 'tlPay',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(44).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("om+3")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/toulian/riskResult',
        name: '/riskResult',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(127).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("vXsM")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/insured/severeness',
        name: 'insuredSevereness',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Sfky")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/insured/momBaby',
        name: 'insuredMomBaby',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(35).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("QdA0")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/insured/benefitEnjoy',
        name: 'benefitEnjoy',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(48).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ThIr")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/insured/accountRisk',
        name: '/accountRisk',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(40).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("aEEB")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/insured/healthNotification',
        name: '/healthNotification',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(69).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("GXdn")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/insured/healthKnow',
        name: '/healthKnow',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(88).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("KCdi")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/insured/healthKnowTK',
        name: '/healthKnowTK',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(100).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("H53O")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/toulian/insuredFormTl',
        name: 'insuredFormTl',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(23).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("V5tv")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/insured/detail/:id',
        name: 'insuredDetail',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(56).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("dmH8")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { requiresAuth: true }
    },
    // 信息披露页下的模块
    {
        path: '/productList/consumer',
        name: 'consumer',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(67).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("HgBZ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { requireShow: true }
    }, {
        path: '/productList/claim',
        name: 'claim',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(111).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("WLhj")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { requireShow: true }
    }, {
        path: '/productList/basicInfo',
        name: 'basicInfo',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(94).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("YF7/")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { requireShow: true }
    }, {
        path: '/productList/partners',
        name: 'partners',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(97).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("uL2P")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { requireShow: true }
    }, {
        path: '/productList/productBx',
        name: 'productBx',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("RC9l")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { requireShow: true }
    }, {
        path: '/productToulian/:code',
        name: 'productToulian',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("0r6p")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/toulian/otherDetaill/:code',
        name: 'otherDetail',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("6i7S")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    },
    // 教育金
    {
        path: '/productEducationMoney/:code',
        name: 'productEducationMoney',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(52).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("idga")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/childrenFundruleDetail',
        name: 'childrenFundruleDetail',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(152).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("4xAl")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/renewal/base/:id',
        name: 'renewalBase',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(50).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("OCoS")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        meta: { requiresAuth: true }
    }, {
        path: '/insured/enjoyLife',
        name: 'insuredZaEnjoyLife',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(26).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("xbkF")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/insured/insuredMillionMedical',
        name: 'insuredMillionMedical',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("hXq/")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/insured/formFollowCar',
        name: 'insuredFormFollowCar',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(32).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("xEYz")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/insured/formPicc',
        name: 'insuredFormPicc',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(38).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("p+jS")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/insured/formAviation',
        name: 'insuredFormAviation',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("bin1")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/insured/leukaemiaBaby',
        name: 'insuredLeukaemiaBaby',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(25).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("FzQZ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/insured/formTreasure',
        name: 'insuredFormTreasure',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(28).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Rxxj")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/insured/formOverseasMedical',
        name: 'insuredOverseasMedical',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(31).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("GLm7")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/insured/formWomen',
        name: 'formWomen',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(29).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("jtf4")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/insured/formHealth',
        name: 'formHealth',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(34).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("O5ug")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/insured/formBase',
        name: 'formBase',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(43).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("o3CF")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/insured/form',
        name: 'insuredForm',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("PFYs")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    },
    // 泰康险录入页（家庭版）
    // {
    //     path: '/insured/insureTK',
    //     name: 'insureTK',
    //     component: resolve => require(['../pages/insured/insureTK.vue'], resolve)
    // },
    {
        path: '/insured/insureTK',
        name: 'insureFamily',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(24).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("+6UA")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    },
    // 平安E生产品
    {
        path: '/insured/medicalPingAn',
        name: 'medicalPingAn',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("0bhf")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    },
    // 和泰重疾与试算非相关信息录入页 by 丁延超
    {
        path: '/insured/seriousillness',
        name: 'insuredSeriousillness',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(27).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("rsJU")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    },
    // {   //和泰重疾 信息展示页 by 丁延超
    //     path: '/insured/seriousillness',
    //     name: 'insuredSeriousillness',
    //     component: resolve => require(['../pages/insured/seriousillness.vue'], resolve)
    // },
    {
        path: '/my/modifyPwd',
        name: 'modifyPwd',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(73).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("BO+5")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/my/myRights',
        name: 'myRights',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(113).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("18Hj")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/my/policy',
        name: 'myPolicy',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(59).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("May5")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/product/twoCodePay',
        name: 'twoCodePay',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(122).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("IO3q")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/product/pay',
        name: '/pay',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(128).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("DC+l")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/product/overseasPay/:id?',
        name: '/overseasPay',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(66).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Gj3A")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/investDetailFa',
        name: 'investDetailFa',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(134).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("adVB")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    },
    // 改版后的支付失败页
    {
        path: '/newInvestDetailFa',
        name: 'newInvestDetailFa',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(140).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Oy4I")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/investDetailSu',
        name: 'investDetailSu',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(138).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("UCZC")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    },
    // 改版后的支付成功页
    {
        path: '/newInvestDetailSu',
        name: 'newInvestDetailSu',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(139).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("/mfg")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/paySuccessTK',
        name: 'paySuccessTK',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(137).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("5FfM")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/renewalSuccess',
        name: 'renewalSuccess',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(136).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("SQ0M")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/settleSuccess',
        name: 'settleSuccess',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(135).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("oA5K")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/login',
        name: 'login',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(71).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("QlWu")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/login/inputPsw',
        name: 'inputPsw',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(72).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ZuWJ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/register/success',
        name: 'registerSuccess',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(129).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("5Iy9")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/forgot',
        name: 'forgot',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(70).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("9ow9")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/login/verification',
        name: 'verification',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(82).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("mYoJ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(105).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("mOgr")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        },
        children: [{
            path: '/',
            name: 'index',
            component: function component(resolve) {
                return __webpack_require__.e/* require */(17).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Qt9A")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }, {
            path: '/articlescrap',
            name: 'articlescrap',
            component: function component(resolve) {
                return __webpack_require__.e/* require */(123).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("JOA9")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }, {
            path: '/find',
            name: 'find',
            component: function component(resolve) {
                return __webpack_require__.e/* require */(93).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Sblu")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }, {
            path: '/my',
            name: 'my',
            component: function component(resolve) {
                return __webpack_require__.e/* require */(91).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("RZjO")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
            }
        }]
    }, {
        path: '/product/sharePoster',
        name: 'sharePoster',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(101).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("fG8y")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/carGround',
        name: '/carGround',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(79).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("SmRn")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/product/carEntry',
        name: 'carEntry',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(65).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("/iml")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/productDetail/:code',
        name: 'productDetail',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("k6mo")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/productDetailFl/:code',
        name: 'productDetailFl',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("HPyt")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/newProductDetail/:code',
        name: 'newProductDetail',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("+zmO")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/productDetail_puhui/:code',
        name: 'productDetail_puhui',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("YuHW")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/find/:code',
        name: 'findClass',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(47).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("NgTv")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/my/link',
        name: 'link',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(95).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("0cHD")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/my/linkInfo',
        name: 'linkInfo',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(84).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("gwAp")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/identity',
        name: 'identity',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(126).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("VOxn")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/bridgeUrl',
        name: 'bridgeUrl',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(133).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("HeiP")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/kostaNeedBill',
        name: 'kostaNeedBill',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(41).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("o6mZ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/platform',
        name: 'platform',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(157).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Dwn/")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/mainClause',
        name: 'mainClause',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(142).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("pbbK")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/withClause',
        name: 'withClause',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(141).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("NAle")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/inform',
        name: 'inform',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(143).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("aTA2")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/entrust',
        name: 'entrust',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(144).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("wY4B")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/three/aboutus',
        name: 'aboutus',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(107).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("LNNO")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/three/information',
        name: 'information',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(116).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("2Dsk")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/three/product',
        name: 'product',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(145).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("spPq")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/three/claimService',
        name: 'claimService',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(115).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("JfT3")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    },
    // 家政财险
    {
        path: '/claim-service',
        name: 'serviCeclaim',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(99).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("HW0C")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/toIndex',
        name: 'toIndex',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(130).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("xb5D")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/landingPage',
        name: 'landingPage',
        component: function component(resolve) {
            return __webpack_require__.e/* require */(131).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("7A94")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/t/:code',
        name: 't'
    }]
});

router.beforeEach(function (to, from, next) {
    // alert(window.location.href);
    if (Object(__WEBPACK_IMPORTED_MODULE_8__utils_util_js__["d" /* getQueryString */])('linkto') && Object(__WEBPACK_IMPORTED_MODULE_8__utils_util_js__["d" /* getQueryString */])('linkto') === '/') {
        sessionStorage['linkto'] = Object(__WEBPACK_IMPORTED_MODULE_8__utils_util_js__["d" /* getQueryString */])('linkto');
    }
    if (Object(__WEBPACK_IMPORTED_MODULE_8__utils_util_js__["d" /* getQueryString */])('wxChannel') === 'gome_xcx') {
        sessionStorage['wxChannel'] = Object(__WEBPACK_IMPORTED_MODULE_8__utils_util_js__["d" /* getQueryString */])('wxChannel');
    }
    // 判断是不是从国美金融APP跳转的
    if (Object(__WEBPACK_IMPORTED_MODULE_8__utils_util_js__["d" /* getQueryString */])('source') === 'app') {
        sessionStorage['source'] = Object(__WEBPACK_IMPORTED_MODULE_8__utils_util_js__["d" /* getQueryString */])('source');
    }
    if (sessionStorage['source'] === 'app' || __WEBPACK_IMPORTED_MODULE_8__utils_util_js__["i" /* isSource */]) {
        // alert(window.location.href);
        var mybsellChannel = Object(__WEBPACK_IMPORTED_MODULE_8__utils_util_js__["d" /* getQueryString */])('mybsellChannel') || 'QD005';
        var sellChannel = Object(__WEBPACK_IMPORTED_MODULE_8__utils_util_js__["d" /* getQueryString */])('sellChannel') || '157310628745091214';
        var platform = Object(__WEBPACK_IMPORTED_MODULE_8__utils_util_js__["d" /* getQueryString */])('platform') || '20';
        sessionStorage.setItem('accessToken/app', Object(__WEBPACK_IMPORTED_MODULE_8__utils_util_js__["d" /* getQueryString */])('accessToken'));
        __WEBPACK_IMPORTED_MODULE_6__utils_storage__["a" /* default */].set('mybsellChannel', mybsellChannel);
        __WEBPACK_IMPORTED_MODULE_6__utils_storage__["a" /* default */].set('sellChannel', sellChannel);
        __WEBPACK_IMPORTED_MODULE_6__utils_storage__["a" /* default */].set('platform', platform);
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_8__utils_util_js__["d" /* getQueryString */])('appEnv')) {
        sessionStorage['appEnv'] = Object(__WEBPACK_IMPORTED_MODULE_8__utils_util_js__["d" /* getQueryString */])('appEnv');
    }
    if (__WEBPACK_IMPORTED_MODULE_8__utils_util_js__["f" /* isGomeHome */] || sessionStorage['appEnv'] === 'gomeHome') {
        document.title = '员工内购专区';
        if (window.location.href === 'm.gomelife.com') {
            _this2.$router.replace('/my');
        } else if (window.location.href === 'm-uat.gomelife.com') {
            _this2.$router.replace('/my');
        }
    }

    //收集链接上的一些需要放到缓存里的参数
    addParamsStorage(to);
    var agentToken = __WEBPACK_IMPORTED_MODULE_7__utils_cookieUtils__["a" /* cookieUtils */].getCookie('token') || Object(__WEBPACK_IMPORTED_MODULE_8__utils_util_js__["d" /* getQueryString */])('token') || '';
    var agentPassId = Object(__WEBPACK_IMPORTED_MODULE_8__utils_util_js__["d" /* getQueryString */])('mybPassId') || '';
    __WEBPACK_IMPORTED_MODULE_7__utils_cookieUtils__["a" /* cookieUtils */].delRootCookie('token');
    //从美云宝跳过来代理人置换token
    if (agentPassId) {
        var _this = _this2;
        // _this.isLoading = true;
        Object(__WEBPACK_IMPORTED_MODULE_5__api_login__["s" /* tokenLoginChange */])(agentPassId).then(function (res) {
            // alert(res);
            if (res.success) {
                if (!sessionStorage['isRefresh']) {
                    sessionStorage['isRefresh'] = '1';
                    window.location.reload();
                }
            }
            next();
        });
    }

    // 从哪个平台跳转过来的  myb：美云保平台
    var linkfrom = Object(__WEBPACK_IMPORTED_MODULE_8__utils_util_js__["d" /* getQueryString */])('linkfrom') || '';
    if (linkfrom === 'myb') {
        // 存储参数
        var _mybsellChannel = Object(__WEBPACK_IMPORTED_MODULE_8__utils_util_js__["d" /* getQueryString */])('mybsellChannel') || 'QD005';
        var _sellChannel = Object(__WEBPACK_IMPORTED_MODULE_8__utils_util_js__["d" /* getQueryString */])('sellChannel') || __WEBPACK_IMPORTED_MODULE_9__constants_constants__["a" /* golbalConstants */].sellChannel;
        var _platform = Object(__WEBPACK_IMPORTED_MODULE_8__utils_util_js__["d" /* getQueryString */])('platform') || '2';
        var mybInviter = Object(__WEBPACK_IMPORTED_MODULE_8__utils_util_js__["d" /* getQueryString */])('mybInviter') || '';
        __WEBPACK_IMPORTED_MODULE_6__utils_storage__["a" /* default */].set('mybsellChannel', _mybsellChannel);
        __WEBPACK_IMPORTED_MODULE_6__utils_storage__["a" /* default */].set('sellChannel', _sellChannel);
        localStorage['sellChannel'] = _sellChannel;
        __WEBPACK_IMPORTED_MODULE_6__utils_storage__["a" /* default */].set('platform', _platform);
        __WEBPACK_IMPORTED_MODULE_6__utils_storage__["a" /* default */].set('mybInviter', mybInviter);
    }
    //如果是从美云保跳转过来且存储了美云保passid，若没有登录态，则调用接口进行置换
    if (sessionStorage['linkfrom'] === 'myb' && sessionStorage['mybPassId']) {
        Object(__WEBPACK_IMPORTED_MODULE_5__api_login__["g" /* isLogin */])().then(function (res) {
            if (!res.success) {
                Object(__WEBPACK_IMPORTED_MODULE_5__api_login__["s" /* tokenLoginChange */])(agentPassId);
            }
        });
    }

    //判断是否为短链接
    if (to.name == 't' && to.params.code) {
        Object(__WEBPACK_IMPORTED_MODULE_5__api_login__["e" /* getFullPath */])(to.params.code).then(function (res) {
            if (res.success) {
                window.location.href = res.data;
            }
        });
    }
    if (localStorage.getItem('inviterOwn') && localStorage.getItem('inviterOwn') !== 'null') {
        __WEBPACK_IMPORTED_MODULE_6__utils_storage__["a" /* default */].set('inviterOwn', localStorage.getItem('inviterOwn'));
    } else {
        localStorage.removeItem('inviterOwn');
    }

    //收集链接上的一些需要放到缓存里的参数
    addParamsStorage(to);
    __WEBPACK_IMPORTED_MODULE_7__utils_cookieUtils__["a" /* cookieUtils */].delRootCookie('token');
    if (agentToken) {
        Object(__WEBPACK_IMPORTED_MODULE_5__api_login__["r" /* tokenChangeLogin */])(agentToken).then(function (res) {
            if (res.success) {
                if (res.data.idStr) {
                    __WEBPACK_IMPORTED_MODULE_6__utils_storage__["a" /* default */].set('inviterOwn', res.data.idStr);
                    __WEBPACK_IMPORTED_MODULE_6__utils_storage__["a" /* default */].setL('inviterOwn', res.data.idStr);
                    __WEBPACK_IMPORTED_MODULE_6__utils_storage__["a" /* default */].setL('phone', res.data.mobile);
                }
            }
            next();
        });
    } else {
        //判断是否有微信相关内容
        if (to.query.appToken) {
            Object(__WEBPACK_IMPORTED_MODULE_5__api_login__["f" /* getSessionByToken */])(to.query.appToken);
        }
        if (to.query.accessToken) {
            Object(__WEBPACK_IMPORTED_MODULE_5__api_login__["f" /* getSessionByToken */])(to.query.accessToken);
        }
        var ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            //判断微信环境
            wxInterceptUtil(to, next);
        } else {
            //浏览器环境
            normalUtil(to, next);
        }
    }
    // }
});

// router.afterEach((to, from) => {
//     setTimeout(()=>{
//         patchIosBlank();
//     },1000);
// });


//微信环境的拦截
function wxInterceptUtil(to, next) {
    var code = to.query.code || Object(__WEBPACK_IMPORTED_MODULE_8__utils_util_js__["d" /* getQueryString */])('code') || '';
    var wxBindFlag = to.query.wxBindFlag || Object(__WEBPACK_IMPORTED_MODULE_8__utils_util_js__["d" /* getQueryString */])('wxBindFlag') || '';
    var unid = to.query.unid;
    // alert(unid);
    if (wxBindFlag) {
        //为微信首次绑定
        if (unid) {
            wxBindUtilUnionId(code, to, next);
        } else {
            wxBindUtil(code, to, next);
        }
    } else {
        // 不是首次绑定，直接换取登录态
        wxLoginUtil(code, to, next);
    }
}

//正常拦截
function normalUtil(to, next) {
    if (to.matched.some(function (record) {
        return record.meta.requiresAuth;
    })) {
        Object(__WEBPACK_IMPORTED_MODULE_5__api_login__["g" /* isLogin */])().then(function (result) {
            //校验这个目标页面是否需要登录
            if (!result.success) {
                checkLoginUtil(to, next);
            } else {
                next();
            }
        });
    } else {
        next();
    }
}

// 微信绑定网站账户辅助方法openid
function wxBindUtil(code, to, next) {
    Object(__WEBPACK_IMPORTED_MODULE_4__api_wechat__["b" /* wechatOpenid */])(code).then(function (result) {
        next(); //因为授权登录成功
    });
}

// 微信绑定网站账户辅助方法UnionId
function wxBindUtilUnionId(code, to, next) {
    Object(__WEBPACK_IMPORTED_MODULE_4__api_wechat__["c" /* wechatUnionId */])(code).then(function (result) {
        next(); //因为授权登录成功
    });
}

//微信授权登录辅助方法
function wxLoginUtil(code, to, next) {
    if (code) {
        Object(__WEBPACK_IMPORTED_MODULE_4__api_wechat__["a" /* wechatLogin */])(code).then(function (result) {
            // 微信登录
            console.log(result);
            if (result && result.success) {
                addLoginStore(result);
                next();
            } else {
                checkLoginUtil(to, next);
            }
        });
    } else {
        //没有code，那就是正常微信页面,正常微信页面也需要判断下登录态
        normalUtil(to, next);
    }
}

/**
 * 登录的一个辅助方法
 * @param { } to
 * @param {*} next
 */
function checkLoginUtil(to, next, type) {
    if (to.matched.some(function (record) {
        return record.meta.requiresAuth;
    })) {
        next({
            path: '/login/passUnify',
            query: {
                redirect: to.fullPath
            }
        });
    } else {
        next();
    }
}

/**
 * 增加缓存
 * @param {*} result
 */
function addLoginStore(result) {
    __WEBPACK_IMPORTED_MODULE_6__utils_storage__["a" /* default */].setL('ccat', true);
    __WEBPACK_IMPORTED_MODULE_6__utils_storage__["a" /* default */].setL('userId', result.data.userId);
    __WEBPACK_IMPORTED_MODULE_6__utils_storage__["a" /* default */].setL('mobile', result.data.userMobile);
    __WEBPACK_IMPORTED_MODULE_6__utils_storage__["a" /* default */].setL('headImgUrl', result.data.headImgUrl);
    __WEBPACK_IMPORTED_MODULE_6__utils_storage__["a" /* default */].setL('nickName', result.data.nickName);
    if (result.data.userId) {
        __WEBPACK_IMPORTED_MODULE_6__utils_storage__["a" /* default */].setL('inviterOwn', result.data.userId);
        __WEBPACK_IMPORTED_MODULE_6__utils_storage__["a" /* default */].set('inviterOwn', result.data.userId);
    }
}

/**
 * 将链接里的参数加入缓存
 * @param {*} to
 */
function addParamsStorage(to) {
    if (to.query) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(to.query).forEach(function (keys) {
            to.query[keys] ? __WEBPACK_IMPORTED_MODULE_6__utils_storage__["a" /* default */].set(keys, to.query[keys]) : '';
        });
    }
}

/* harmony default export */ __webpack_exports__["a"] = (router);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),

/***/ "aNLv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return encryptAllRsa; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return encryptRsa; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return encryptDes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return encryptAes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return decryptAes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return encryptAesKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return encryptAesUuid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsbridge_jsbridge__ = __webpack_require__("Qtao");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_crypto_js__ = __webpack_require__("Av7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_crypto_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__("oFuF");



var _this = this;

/**
 * Created by admin on 2017/3/31.
 * 加密解密工具类
 */




var rsaKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC7mK/FpaUGw5kNUDuVs9H/OflISB9Rh2yMAl1Pi6DyF9m6h5MxNwd2SDEr2wlk+aRK79JcjPu1++00lONpFAt+lMrEBLvTMHZVQ+kWgVX0+jGKCab7xoKvlZTPNjlNz9N3u4g6KabBDXIZcJa/d8esZvzLss80SNQU89B+vq1NZQIDAQAB';
var aesKey = 'b2070e309409969b';
var aesKeyAes = 'AXjmiqa4wKtEYKQz2Pd21rS8smj9TGx8S';

var encryptAllRsa = function encryptAllRsa(content) {
    // RSA 加密
    var encrypt = new JSEncrypt();
    encrypt.setPublicKey(rsaKey);
    var encryptContent = encrypt.encrypt(content);
    if (encryptContent) {
        return encodeURIComponent(encryptContent);
    }
    return '';
};

var encryptRsa = function encryptRsa(content) {
    // RSA 加密
    var encrypt = new JSEncrypt();
    encrypt.setPublicKey(rsaKey);
    var encryptContent = encrypt.encrypt(content);
    if (encryptContent) {
        return encryptContent;
    }
    return '';
};

var encryptDes = function encryptDes(content) {
    // DES 解密
    return strDec(content, aesKey, '', '');
};

function getKey(key) {
    var realKey = __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.SHA1(key);
    realKey = __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.SHA1(realKey).toString().substring(0, 32); //真正的key
    return realKey;
};

var encryptAes = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(content) {
        var aesKey, key, encrypt;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        //aes加密
                        aesKey = sessionStorage['aesKey'] && sessionStorage['aesKey'];
                        key = getKey(aesKey);
                        encrypt = __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.AES.encrypt(content, __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.enc.Hex.parse(key), {
                            mode: __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.mode.ECB,
                            padding: __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.pad.Pkcs7
                        });
                        return _context.abrupt('return', encrypt.ciphertext.toString(__WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.enc.Hex).replace(/\+/g, '%2B').replace(/\&/g, '%26'));

                    case 4:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this);
    }));

    return function encryptAes(_x) {
        return _ref.apply(this, arguments);
    };
}();

var decryptAes = function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(content) {
        var aesKey, realKey, decrypt;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        //aes解密
                        aesKey = sessionStorage['aesKey'] && sessionStorage['aesKey'];
                        realKey = getKey(aesKey);
                        decrypt = __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.AES.decrypt({ ciphertext: __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.enc.Hex.parse(content) }, __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.enc.Hex.parse(realKey), {
                            mode: __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.mode.ECB,
                            padding: __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.pad.Pkcs7
                        });
                        return _context2.abrupt('return', decrypt.toString(__WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.enc.Utf8));

                    case 4:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, _this);
    }));

    return function decryptAes(_x2) {
        return _ref2.apply(this, arguments);
    };
}();

//用来加密aes(h5自己的aes,国美金融获取的aes)
var encryptAesKey = function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var keyh5, key, encrypt;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        // if (isGomeApp || sessionStorage['source/from'] == 'app') {
                        //     var aesObj;
                        //     if (navigator.userAgent.indexOf('gomeFinancialVersion') > -1) {
                        //         aesObj = await jsbridge.getAesSecretKey()
                        //     } else {
                        //         aesObj = JSON.stringify({code : '500'})
                        //     }
                        //     let keyapp = aesObj && typeof(aesObj) == 'string' && JSON.parse(aesObj).aeskey ? JSON.parse(aesObj).aeskey : 'K4aQvVkEwFYNn9PT';
                        //     this.$store.commit('setAesKey', keyapp)
                        // } else {
                        keyh5 = 'K4aQvVkEwFYNn9PT';

                        sessionStorage['aesKey'] = keyh5;
                        key = getKey(aesKeyAes);
                        encrypt = __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.AES.encrypt(keyh5, __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.enc.Hex.parse(key), {
                            mode: __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.mode.ECB,
                            padding: __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.pad.Pkcs7
                        });
                        return _context3.abrupt('return', encrypt.ciphertext.toString(__WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.enc.Hex));

                    case 5:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, _this);
    }));

    return function encryptAesKey() {
        return _ref3.apply(this, arguments);
    };
}();

//用来加密uuid(h5自己的uuid,国美金融获取的uuid)
var encryptAesUuid = function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var uuid, key, encrypt;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        // if (isGomeApp || sessionStorage['source/from'] == 'app') {
                        //     var aesObj;
                        //     if (navigator.userAgent.indexOf('gomeFinancialVersion') > -1) {
                        //         aesObj = await jsbridge.getAesSecretKey()
                        //     } else {
                        //         aesObj = JSON.stringify({code : '500'})
                        //     }
                        //     let keyapp = aesObj && typeof(aesObj) == 'string' && JSON.parse(aesObj).aeskey ? JSON.parse(aesObj).aeskey : 'K4aQvVkEwFYNn9PT';
                        //     this.$store.commit('setAesKey', keyapp);
                        // } else {}
                        uuid = '';

                        sessionStorage['aseUuid'] = uuid;
                        key = getKey(aesKeyAes);
                        encrypt = __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.AES.encrypt(uuid, __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.enc.Hex.parse(key), {
                            mode: __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.mode.ECB,
                            padding: __WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.pad.Pkcs7
                        });
                        return _context4.abrupt('return', encrypt.ciphertext.toString(__WEBPACK_IMPORTED_MODULE_3_crypto_js___default.a.enc.Hex));

                    case 5:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, _this);
    }));

    return function encryptAesUuid() {
        return _ref4.apply(this, arguments);
    };
}();

/***/ }),

/***/ "cK6X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eOxC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  哈哈，你个逗比~~\n  "+_vm._s(_vm.count)+"\n  "),_c('input',{staticClass:"search",attrs:{"type":"text"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ejIc":
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ "l+I4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__("yalW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__("UTg/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__("/8vw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getters__ = __webpack_require__("WMeU");







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* state */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* mutations */],
    actions: __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* actions */],
    getters: __WEBPACK_IMPORTED_MODULE_5__getters__["a" /* getters */]
}));

/***/ }),

/***/ "l9XB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oFuF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPriceSuf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getPricePref; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkCardNoBirthdayIsOk; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return urlencode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getQueryString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return patchIosBlank; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isGomeHome; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isSource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isGomePay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isYKApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isMeiBan; });
/* unused harmony export iszkl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isAndroid; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validate__ = __webpack_require__("E4LH");


var getPriceSuf = function getPriceSuf(price) {
    //截取价格小数部分
    if (price) {
        price = price + '';
        var priceArray = price.split('.');
        if (priceArray.length == 2) {
            var priceSuf = priceArray[1];
            if (priceSuf.length == 1) {
                priceSuf = '.' + priceSuf + '0';
                return priceSuf;
            } else if (priceSuf.length == 2) {
                return '.' + priceSuf;
            }
        }
        return '';
    }
};

var getPricePref = function getPricePref(price) {
    //截取价格整数部分
    if (price) {
        price = price + '';
        var pricePref = price.split('.')[0];
        return pricePref;
    }
    return price;
};

var checkCardNoBirthdayIsOk = function checkCardNoBirthdayIsOk(certificateNo, ageNumStart, ageNumEnd) {
    var sureDateNum = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    var birthday = certificateNo.substring(6, 14);
    if (birthday.length == 8) {
        birthday = birthday.substring(0, 4) + '-' + birthday.substring(4, 6) + '-' + birthday.substring(6, 8);
        // console.log(111111111,birthday);
        return __WEBPACK_IMPORTED_MODULE_1__validate__["a" /* default */].checkBirthdayIsOk(birthday, ageNumStart, ageNumEnd);
    }
    return '';
};

//encodeURI
var urlencode = function urlencode(str) {
    str = (str + '').toString();
    return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
};

var getQueryString = function getQueryString(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) {
        return decodeURIComponent(r[2]);
    }
    return null;
};

//修复ios页面下拉留白的问题
var patchIosBlank = function patchIosBlank() {
    var inputK = document.getElementsByTagName('input');
    var textArea = document.getElementsByTagName('textarea');
    //需要手动给有输入功能的div框加上类名 divIos
    var divIos = document.getElementsByClassName('divIos');
    var input = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(inputK), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(textArea), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(divIos));
    var windowHeight = window.innerHeight;
    for (var i = 0; i < input.length; i++) {
        input[i].addEventListener('blur', function () {
            var windowFocusHeight = window.innerHeight;
            if (windowHeight === windowFocusHeight) {
                return;
            };
            var currentPosition = void 0;
            var speed = 1; //页面滚动距离
            currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
            currentPosition -= speed;
            window.scrollTo(0, currentPosition); //页面向上滚动
            currentPosition += speed; //speed变量
            window.scrollTo(0, currentPosition); //页面向下滚动
        });
    }
};

// 判断是否是国美家app 环境
// export const isGomeHome = sessionStorage['appEnv'] && sessionStorage['appEnv'] === 'gomeHome';
var isGomeHome = !!window.navigator.userAgent.toLowerCase().match(/gomehome/ig);
// !!window.navigator.userAgent.toLowerCase().match(/gomehome/ig);

// 判断是否是国美金融app 环境
var isSource = sessionStorage['source'] && sessionStorage['source'] === 'app';
// !!window.navigator.userAgent.toLowerCase().match(/gomehome/ig);

// 判断是不是美付保环境
var isGomePay = !!window.navigator.userAgent.toLowerCase().match(/gomePay/ig);
// export const isGomePay = null;

// 判断是否是易卡APP环境
var isYKApp = !!window.navigator.userAgent.toLowerCase().match(/gomecard/ig);

// 判断是不是美办app环境
var isMeiBan = !!window.navigator.userAgent.toLowerCase().match(/smartoffice/ig);

// 判断是不是真快乐app环境、
var iszkl = !!window.navigator.userAgent.toLowerCase().match(/app-shangcheng/ig);
// 判断是不是安卓
var isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1;

/***/ }),

/***/ "sSTJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var globalInterval = {};
var timer;
var globalTime = 0;
globalInterval.set = function (time, callback) {
    if (timer) {
        return;
    }
    timer = setInterval(function () {
        time--;
        //consoe.log.log(time);
        globalTime = time;
        if (time === 0) {
            if (callback) {
                callback();
            }
            clearInterval(timer);
            timer = '';
        }
    }, 1000);
};
globalInterval.clear = function (callback) {
    if (callback) {
        callback();
    }
    clearInterval(timer);
    globalTime = 0;
};
globalInterval.getTime = function () {
    return globalTime;
};
/* harmony default export */ __webpack_exports__["a"] = (globalInterval);

/***/ }),

/***/ "v2ns":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app'
});

/***/ }),

/***/ "yalW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_storage__ = __webpack_require__("VKKs");


// 一些默认值
// 投保时候身份证上传录入信息
var insuredIdCardUploadInfo = {
    holder: {
        IF: {
            category: 'IF',
            fileName: '',
            fileType: '',
            file: '',
            upload: ''
        },
        IB: {
            category: 'IB',
            fileName: '',
            fileType: '',
            file: '',
            upload: ''
        }
    },
    // 被保人 可能存在多个
    insurers: [{

        IF: {
            category: 'IF',
            fileName: '',
            fileType: '',
            file: '',
            upload: ''
        },
        IB: {
            category: 'IB',
            fileName: '',
            fileType: '',
            file: '',
            upload: ''
        }
    }]
};

// 产品自身属性信息
var productInfo = {
    productCode: '', // 产品id
    productName: '', // 产品id
    allPdfFile: '', // 所有的 pdf 文件
    insuranceScope: [// 产品保障范围
        // { name: '被保人年龄', value: '' },
        // { name: '被保人性别', value: '' },
        // { name: '保障金额', value: '' },
        // { name: '保险期限', value: '' },
        // { name: '缴费期间', value: '' },
        // { name: '附加险', value: '' },
    ]
};

// 保单录入信息
var insureInfo = {
    insuredInfo: [], // 被保人信息模板及数据
    holderInfo: [], // 投保人信息
    confirmSubmitId: '', // 信息确认页 confirmSubmitId id
    price: '',
    totalPrice: '',
    timeLimit: [],
    bankInfo: []
};

// 美泰保重疾试算
var information = {
    chargeYear: '', // 缴费期间
    amount: '' + '0000', // 保障金额
    productCode: '', // 产品id
    insured: [{
        birthDate: '', //被保人出生日期
        sex: '' // 被保人性别
    }]
};

// 登录页的一些信息
var login = {
    phone: '' // 用户手机号
};

var OrderProcessUploadInfo = {};

var state = {
    // 投保时候身份证上传录入信息
    insuredIdCardUploadInfo: __WEBPACK_IMPORTED_MODULE_0__utils_storage__["a" /* default */].get('insuredIdCardUploadInfo') ? JSON.parse(__WEBPACK_IMPORTED_MODULE_0__utils_storage__["a" /* default */].get('insuredIdCardUploadInfo')) : insuredIdCardUploadInfo,
    productInfo: __WEBPACK_IMPORTED_MODULE_0__utils_storage__["a" /* default */].get('productInfo') ? JSON.parse(__WEBPACK_IMPORTED_MODULE_0__utils_storage__["a" /* default */].get('productInfo')) : productInfo,
    insureInfo: __WEBPACK_IMPORTED_MODULE_0__utils_storage__["a" /* default */].get('insureInfo') ? JSON.parse(__WEBPACK_IMPORTED_MODULE_0__utils_storage__["a" /* default */].get('insureInfo')) : insureInfo,
    information: __WEBPACK_IMPORTED_MODULE_0__utils_storage__["a" /* default */].get('information') ? JSON.parse(__WEBPACK_IMPORTED_MODULE_0__utils_storage__["a" /* default */].get('information')) : information,
    login: __WEBPACK_IMPORTED_MODULE_0__utils_storage__["a" /* default */].get('login') ? JSON.parse(__WEBPACK_IMPORTED_MODULE_0__utils_storage__["a" /* default */].get('login')) : login,
    OrderProcessUploadInfo: __WEBPACK_IMPORTED_MODULE_0__utils_storage__["a" /* default */].get('OrderProcessUploadInfo') ? JSON.parse(__WEBPACK_IMPORTED_MODULE_0__utils_storage__["a" /* default */].get('OrderProcessUploadInfo')) : OrderProcessUploadInfo
};

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.6c43a09f6069c3882e84.js